<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">Boletos</h3>
            </div>
            <div class="col-6 text-right">
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
          <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              placeholder="Boletos por página"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item.value"
                :label="item.descripcion"
                :value="Number(item.value)"
              >
              </el-option>
          </el-select>

          <el-select
              class="select-primary pagination-select"
              v-model="type"
              placeholder="Tipos de filtro"
            >
              <el-option
                class="select-primary"
                v-for="item in filters.types"
                :key="item.value"
                :label="item.descripcion"
                :value="Number(item.value)"
              >
              </el-option>
          </el-select>

            <div>
              <form class="apolo-borde">
                <base-input
                  v-model="query"
                  type="search"
                  append-icon="fas fa-search"
                  placeholder="Buscar..."
                  clearable
                  inputClasses="apolo-borde"
                />
              </form>
            </div>
          </div>
          <div style="overflow-x: scroll; width: auto;">
          <el-table
            class="table-responsive align-items-center table-flush"
            header-row-class-name="thead-light"
            :data="boletos"
            @sort-change="sortChange"
          >
            <div slot="empty" v-if="loading">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>

            <div slot="empty" v-if="boletos">
              Sin datos disponibles
            </div>

            <el-table-column label="#" prop="attributes.id" min-width="90px"/>
            <el-table-column label="Nombre Completo" prop="attributes.nombre_pasajero" min-width="180px"/>
            <el-table-column label="Edad" prop="attributes.edad" min-width="90px"/>
            <el-table-column label="Email" prop="attributes.email" min-width="200px"/>
            <el-table-column label="Teléfono" prop="attributes.telefono" min-width="130px"/>
            <el-table-column label="Fecha salida" min-width="180px">
                <div slot-scope="{ row }" class="table-actions">
                  <span>{{row.attributes.fecha_salida | moment('DD-MM-YYYY HH:mm')}}</span>
                </div>
            </el-table-column>
            <el-table-column label="# Corrida" prop="attributes.corrida_id" min-width="120px"/>
            <el-table-column label="# Sub-Corrida" prop="attributes.subcorrida_id" min-width="150px"/>
            <el-table-column label="Reserva" prop="attributes.status_reserva" min-width="130px"/>
            <el-table-column align="center" min-width="120px">
              <div slot-scope="{ row }" class="table-actions">
                <base-button class="hover-apolo" type="primary" icon size="sm" @click="showBoleto(row)">
                  <span class="btn-inner--text">Ver</span>
                </base-button>
              </div>
          </el-table-column>
          </el-table>
          </div>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center flex-wrap"
        >
          <base-pagination
            class="pagination-no-border justify-content-right"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          />
        </div>
      </card>
    </div>
    <!-- MODAL VER -->
    <modal :show.sync="showVerBoletoModal" modal-classes="modal-primary" size="lg">
      <form v-if="boleto_info != null" class="new-event--form">
        <div class="row mt-0 mb-0">
          <h6 v-if="boleto_info != null" slot="header" class="modal-title mb-3 ml-3">Información de boleto #{{boleto_info.id}}</h6>
          <span v-if="boleto_info.es_blanco === 0 || (boleto_info.corrida_id != null && boleto_info.subcorrida_id != null && boleto_info.asient0 != null)" class="col-12">Corrida: #{{boleto_info.corrida_id}}, Sub-corrida: #{{boleto_info.subcorrida_id}}</span>
          <span v-if="boleto_info.es_blanco === 0 || (boleto_info.corrida_id != null && boleto_info.subcorrida_id != null && boleto_info.asient0 != null)" class="col-12 mb-3">Fecha/Hora de salida: {{boleto_info.fecha_salida | moment('DD-MM-YYYY HH:mm')}}</span>

          <span v-if="boleto_info.es_blanco === 0 || (boleto_info.corrida_id != null && boleto_info.subcorrida_id != null && boleto_info.asient0 != null)" class="col-12">Terminal origen: {{boleto_info.nombre_terminal_origen}}</span>
          <span v-if="boleto_info.es_blanco === 0 || (boleto_info.corrida_id != null && boleto_info.subcorrida_id != null && boleto_info.asient0 != null)" class="col-12">Subida: {{boleto_info.paradero_origen}}</span>
          <span v-if="boleto_info.es_blanco === 0 || (boleto_info.corrida_id != null && boleto_info.subcorrida_id != null && boleto_info.asient0 != null)" class="col-12">Terminal destino: {{boleto_info.nombre_terminal_destino}}</span>
          <span v-if="boleto_info.es_blanco === 0 || (boleto_info.corrida_id != null && boleto_info.subcorrida_id != null && boleto_info.asient0 != null)" class="col-12">Bajada: {{boleto_info.paradero_destino}}</span>

          <span class="col-12 mt-3" v-if="(boleto_info.es_blanco === 1)">Es blanco: Si</span>
          <span class="col-12 mt-3" v-else>Es blanco: No</span>
          <span class="col-12">Pasajero: {{boleto_info.nombre_pasajero}}</span>
          <span v-if="boleto_info.es_blanco === 0 || (boleto_info.corrida_id != null && boleto_info.subcorrida_id != null && boleto_info.asient0 != null)" class="col-12">Asiento: #{{boleto_info.asiento}} {{boleto_info.categoria_asiento.nombre}}</span>
          <span class="col-12">Edad: {{boleto_info.edad}}</span>
          <span class="col-12">Email: {{boleto_info.email}}</span>
          <span class="col-12">Teléfono: {{boleto_info.telefono}}</span>
          <span class="col-12" v-if="boleto_info.descuento">Descuento: {{boleto_info.descuento.nombre}}. <span v-if="boleto_info.datos_descuento_autorizado_por">Autorizado por {{boleto_info.datos_descuento_autorizado_por.name}}</span></span>
          <span class="col-12" v-if="boleto_info.cortesia_razon">Razón cortesía: {{boleto_info.cortesia_razon}}.</span>
          
          <span class="col-12 mb-3">Precio: ${{boleto_info.precio_lista}}</span>
          
          <span class="col-12">Pagos recibidos:</span>
        </div> 
          <el-table
            class="table-responsive align-items-center table-flush"
            header-row-class-name="thead-light"
            :data="boleto_info.pagos_recibidos"
            @sort-change="sortChange"
          >
            <div slot="empty" v-if="loading">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>

            <div slot="empty" v-if="boleto_info.pagos_recibidos">
              Sin datos disponibles
            </div>

            <el-table-column label="Fecha">
                <div slot-scope="{ row }" class="table-actions">
                  <span>{{row.created_at | moment('DD-MM-YYYY HH:mm')}}</span>
                </div>
            </el-table-column>
            <el-table-column label="Motivo" prop="motivo" />
            <el-table-column label="Monto">
                <div slot-scope="{ row }" class="table-actions">
                  <span>${{row.monto}}</span>
                </div>
            </el-table-column>
            <el-table-column label="Método" prop="metodo" />
            <el-table-column label="Agencia">
                <div slot-scope="{ row }" class="table-actions">
                  <span v-if="row.vendido_en != null">{{row.vendido_en.nombre}}</span>
                </div>
            </el-table-column>
            <el-table-column label="Usuario">
                <div slot-scope="{ row }" class="table-actions">
                  <span v-if="row.creado_por != null">{{row.creado_por.username}}</span>
                </div>
            </el-table-column>
          </el-table>
        <div class="row mt-3">
          <span class="col-12" v-if="(boleto_info.fue_reserva === 1)">Creado como reserva: SI</span>
          <span class="col-12" v-else>Creado como reserva: No</span>
          <span class="col-12">Status de reserva: {{boleto_info.status_reserva}}</span>
          <span class="col-12" v-if="boleto_info.fecha_inicio_reserva">Fecha inicio de reserva: {{boleto_info.fecha_inicio_reserva | moment('DD-MM-YYYY HH:mm:ss')}}</span>
          <span class="col-12 mb-3" v-if="boleto_info.fecha_limite_reserva">Fecha límite de reserva: {{boleto_info.fecha_limite_reserva | moment('DD-MM-YYYY HH:mm:ss')}}</span>
          
          <span class="col-12 mb-3">Emitido: {{boleto_info.lugar_emision}}</span>
          
          <span class="col-12">Equipaje extra:</span>
        </div>
        <div class="row">
          <div class="col-7">
          <el-table
            class="table-responsive align-items-center table-flush"
            header-row-class-name="thead-light"
            :data="boleto_info.equipajes"
            @sort-change="sortChange"
          >
            <div slot="empty" v-if="loading">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>

            <div slot="empty" v-if="boleto_info.equipajes">
              Sin datos disponibles
            </div>

            <el-table-column label="Fecha">
                <div slot-scope="{ row }" class="table-actions">
                  <span>{{row.created_at | moment('DD-MM-YYYY HH:mm')}}</span>
                </div>
            </el-table-column>
            <el-table-column label="# Pieza equipaje" prop="id" />
          </el-table>
          </div>
        </div>
        <div class="row mt-3">
          <span class="col-12">Historial de eventos:</span>
          <div class="card ml-3 mr-3 col-11" style="overflow-y:scroll; height:100px;">
            <div class="card-body" v-for="evento in boleto_info.historial_eventos" :key="evento.id">
              <span>-{{evento.fecha_evento | moment('DD-MM-YYYY HH:mm')}}
                    <span v-if="evento.creado_por != null">
                      {{evento.creado_por.username}}.
                    </span>
                    <span>
                      {{' '+evento.descripcion}}.
                    </span>
              </span>
            </div>
          </div>
        </div>
        <div v-if="(boleto_info != null)" class="row ml-1 mr-1">
          <button v-if="boleto_info.liquidado === 1 && boleto_info.abordado === 0 && boleto_info.esta_anulado === 0" type="button" class="btn btn-default hover-apolo col-3" @click="canjeBoleto()">Canje Boleto</button>
          <button v-if="boleto_info.liquidado === 1 && boleto_info.abordado === 0 && boleto_info.esta_anulado === 0" type="button" class="btn btn-default hover-apolo col-3" @click="validatePermisoAnular()">Anular Boleto</button>
          <button v-if="boleto_info.fue_reserva === 1 && (boleto_info.esta_anulado === 1 && boleto_info.suma_movimientos > 0 || boleto_info.esta_anulado === 0) && boleto_info.status_reserva != 'Confirmada'" type="button" class="btn btn-default hover-apolo col-3" @click="getVerReserva(boleto_info.id)">Ver Reserva</button>
        </div>
        <div class="row mt-3 ml-1 mr-1">
          <button v-if="boleto_info.liquidado === 1 && boleto_info.abordado === 0 && boleto_info.esta_anulado === 0" type="button" class="btn btn-default hover-apolo col-4" @click="showPayEquipajeExtraModal = true">Vender equipaje extra</button>
          <button v-if="boleto_info.liquidado === 1 && boleto_info.abordado === 0 && boleto_info.esta_anulado === 0" type="button" class="btn btn-default hover-apolo col-3" @click="showEditarPasajeroModal = true">Editar pasajero</button>
          <button v-if="boleto_info.liquidado === 1 && boleto_info.abordado === 0 && boleto_info.es_blanco === 0 && boleto_info.esta_anulado === 0" type="button" class="btn btn-default hover-apolo col-3" @click="validateReimprimirBoleto(boleto_info.id)">Re-imprimir boleto</button>
        </div>
      </form>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      <template slot="footer">
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="salirVer()">Cerrar</button>
      </template>
      <!-- MODAL ANULAR BOLETO -->
      <modal :show.sync="showAnularBoletoModal" :hasParent="true" modal-classes="modal-primary" size="sm">
        <h6 v-if="boleto_info != null" slot="header" class="mb-0 modal-title">Anulación de boleto #{{boleto_info.id}}</h6>
        <form v-if="boleto_info != null" class="new-event--form" @submit.prevent="anularBoletoFinal">
          <span>¿Desea Anular el boleto? </span>
          <span>Se realizará un egreso por <strong>${{calculatePagosRecibidos}}</strong></span>
          <base-input label="Detalles de anulación:">
            <textarea v-model="anularBoleto.motivo_anulado" class="form-control" rows="4"></textarea>
          </base-input>
          <validation-error :errors="apiValidationErrors.password"/>
          <validation-error :errors="apiValidationErrors.permiso"/>
          <validation-error :errors="apiValidationErrors.motivo_anulado"/>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="anularBoletoFinal(boleto_info.id)">Aceptar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal()">Cancelar</button>
        </template>
      </modal>
      <!-- MODAL AUTORIZA ANULAR BOLETO -->
      <modal :show.sync="showAutorizarAnularBoletoModal" :hasParent="true" modal-classes="modal-primary" size="sm">
          <h6 slot="header" class="mb-0 modal-title">Autorizar anular boleto</h6>
          <form class="new-event--form" @submit.prevent="authAnularBoleto">
            
            <base-input label="Token"
                        placeholder="Ingrese token"
                        v-model="auth.token"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.token"/>
            <!--
            <base-input label="Usuario"
                        placeholder="Ingrese usuario"
                        v-model="auth.usuario"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.usuario" />
            <base-input label="Contraseña"
                        placeholder="Ingrese contraseña"
                        v-model="auth.password"
                        type="password"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.password"/>
            <validation-error :errors="apiValidationErrors.permiso"/>
            -->
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
          <template slot="footer">
            <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="authAnularBoleto">Autorizar</button>
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal()">Cancelar</button>
          </template>
      </modal>
      <!-- MODAL AUTORIZA REIMPRIMIR BOLETO -->
      <modal :show.sync="showAutorizarReimprimirBoletoModal" :hasParent="true" modal-classes="modal-primary" size="sm">
          <h6 slot="header" class="mb-0 modal-title">Autorizar reimpresión boleto</h6>
          <form class="new-event--form" @submit.prevent="authReimprimirBoleto">
            
            <base-input label="Token"
                        placeholder="Ingrese token"
                        v-model="auth.token"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.token"/>
            <!--
            <base-input label="Usuario"
                        placeholder="Ingrese usuario"
                        v-model="auth.usuario"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.usuario" />
            <base-input label="Contraseña"
                        placeholder="Ingrese contraseña"
                        v-model="auth.password"
                        type="password"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.password"/>
            <validation-error :errors="apiValidationErrors.permiso"/>
            -->
            
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
    
          <template v-if="boleto_info != null" slot="footer">
            <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="authReimprimirBoleto(boleto_info.id)">Autorizar</button>
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal()">Cancelar</button>
          </template>
      </modal>
      <!-- MODAL EDITAR NOMBRE PASAJERO BOLETO -->
      <modal :show.sync="showEditarPasajeroModal" :hasParent="true" modal-classes="modal-primary" size="sm">
          <h6 v-if="boleto_info != null" slot="header" class="mb-0 modal-title">Información de pasajero en boleto #{{boleto_info.id}}</h6>
          <form class="new-event--form" @submit.prevent="editarPasajeroBoleto">
            <base-input label="Nombre completo"
                        placeholder="Ingrese nombre"
                        v-model="editarNombrePasajeroBoleto.nombre_pasajero"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.nombre_pasajero" />
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
    
          <template v-if="boleto_info != null" slot="footer">
            <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="editarPasajeroBoleto(boleto_info.id)">Guardar</button>
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal()">Cancelar</button>
          </template>
      </modal>
      <!-- MODAL VER RESERVA BOLETO -->
      <modal :show.sync="showVerReservaModal" :hasParent="true" modal-classes="modal-primary" size="xl">
          <h6 v-if="boleto_info != null" slot="header" class="mb-0 modal-title">Boletos reservados asociados al boleto #{{boleto_info.id}}</h6>
          <form class="new-event--form" @submit.prevent="editarPasajeroBoleto">
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="boletos_reservados"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>
  
              <div slot="empty" v-if="boletos_reservados">
                Sin datos disponibles
              </div>
              
              <el-table-column label=" ">
                <div slot-scope="{ row }" class="table-actions">
                  <base-checkbox v-model="row.selected" :disabled="row.attributes.status_reserva === 'Confirmada'"></base-checkbox>
                </div>
              </el-table-column>
              <el-table-column label="#" prop="attributes.id" />
              <el-table-column label="Nombre completo" prop="attributes.nombre_pasajero" />
              <el-table-column label="# Corrida" prop="attributes.corrida_id" />
              <el-table-column label="# Sub Corrida" prop="attributes.subcorrida_id" />
              <el-table-column label="Asiento" prop="attributes.asiento" />
              <el-table-column label="Costo">
                <div slot-scope="{ row }" class="table-actions">
                  <span>${{row.attributes.monto_total_pagar}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Abonado">
                <div slot-scope="{ row }" class="table-actions">
                  <span>${{row.attributes.abonado}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Reserva" prop="attributes.status_reserva" />
            </el-table>
            <validation-error :errors="apiValidationErrors.nombre_pasajero" />
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
    
          <template v-if="boleto_info != null" slot="footer">
            <div class="text-left">
              <select class="form-control" v-model="selectReservaValue">
                <option value="inicial" disabled>Con seleccionados</option>
                <option v-if="boleto_info.esta_anulado === 0" value="confirmar">Confirmar reserva (Pagando ${{calculateTotalPagoReserva}})</option>
                <option v-if="verBotonReserva" value="anular">Anular reserva (Devolviendo ${{calculateTotalDevolucionReserva}})</option>
              </select>
            </div>
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal()">Cerrar</button>
          </template>
          <!-- MODAL PAGAR CONFIRMAR RESERVA-->
          <modal :show.sync="showPayConfirmarReservaModal" :hasParent="true" modal-classes="modal-primary" size="sm">
            <h6 slot="header" class="mt-0 modal-title">Pago final de reserva de boleto(s)</h6>
            <form v-if="showPayConfirmarReservaModal" class="new-event--form mt-0">
              <div class="row">
                <span class="col-12">Total a pagar: ${{calculateTotalPagoReserva}}</span>
                <span class="col-12">Métodos de pago</span>
                <base-checkbox class="col-9 ml-3" v-model="confirmarReserva.efectivo" :disabled="confirmarReserva.pago_tarjeta">
                  Efectivo
                </base-checkbox>
                <span class="col-12 text-right">Cantidad restante a pagar MXN <strong>${{calculateRestanteReserva}}</strong></span>
                <span class="col-8 text-right">Se paga con MXN</span>
                <ValidationProvider class="col-4 text-right" name="Cantidad MXN" rules="integer:0,100000" v-slot="{ errors }">
                  <base-input
                    :disabled="confirmarReserva.pago_tarjeta"
                    placeholder="Cantidad"
                    v-model="confirmarReserva.efectivo_mxn"
                  />
                  <validation-error class="col-12" :errors="errors" />
                </ValidationProvider>
                <!---
                <span class="col-8 text-right">Se paga con USD</span>
                <ValidationProvider class="col-4 text-right" name="cantidad USD" rules="integer:0,100000" v-slot="{ errors }">
                  <base-input
                    placeholder="Cantidad"
                    v-model="confirmarReserva.efectivo_usd"
                  />
                  <validation-error class="col-12" :errors="errors" />
                </ValidationProvider>
                <span class="col-12 text-right">Tipo de cambio: ${{tasa_usd_mxn}} En pesos: ${{tasa_usd_mxn * confirmarReserva.efectivo_usd}}</span>
                -->
                <span class="col-12 text-right">Cambio: ${{calculateCambioReserva}}</span>

                <base-checkbox class="col-9 ml-3" v-model="confirmarReserva.pago_tarjeta" :disabled="confirmarReserva.efectivo">
                  Tarjeta
                </base-checkbox>
                <pulse-loader class="text-center col-12" v-if="loadingSpinner" :loading="loadingSpinner" :color="color" :size="size"></pulse-loader>
                <div v-else class="col-12">
                  <p v-if="mensaje_pago_tarjeta != null" class="col-12" style="color: green !important; margin-left: -15px !important;">{{ mensaje_pago_tarjeta }}</p>
                  <p v-if="mensaje_error_pago_tarjeta != null" class="col-12" style="color: red !important; margin-left: -15px !important;">{{ mensaje_error_pago_tarjeta }}</p>
                  <div style="margin-top: -20px !important;">
                    <ValidationProvider class="col-12" name="cantidad a pagar con tarjeta" rules="integer:1,100000" v-slot="{ errors }">
                      <base-input v-if="confirmarReserva.pago_tarjeta"
                        :disabled="disabledCancelPay"
                        placeholder="Cantidad a pagar"
                        v-model="confirmarReserva.tarjeta"
                      />
                      <validation-error :errors="errors" />
                    </ValidationProvider>
                  </div>
                  <div style="margin-top: -20px !important;">
                    <base-input v-if="confirmarReserva.pago_tarjeta"
                      disabled
                      placeholder="Folio tarjeta"
                      v-model="confirmarReserva.folio_tarjeta"
                    />
                    <validation-error :errors="apiValidationErrors.folio_tarjeta" />
                  </div>
                </div>
                <!--
                <base-checkbox class="col-9 ml-3" v-model="confirmarReserva.pago_deposito">
                  Depósito a cuenta
                </base-checkbox>
                <ValidationProvider class="col-12" name="cantidad a pagar con deposito" rules="integer:1,100000" v-slot="{ errors }">
                  <base-input v-if="confirmarReserva.pago_deposito"
                    placeholder="Cantidad a pagar"
                    v-model="confirmarReserva.deposito"
                  />
                  <validation-error class="col-12" :errors="errors" />
                </ValidationProvider>
                <ValidationProvider class="col-12" name="folio de pago con deposito" rules="numeric" v-slot="{ errors }">
                  <base-input v-if="confirmarReserva.pago_deposito"
                    placeholder="Folio deposito"
                    v-model="confirmarReserva.folio_deposito"
                  />
                  <validation-error class="col-12" :errors="errors" />
                </ValidationProvider>
                <validation-error class="col-12" :errors="apiValidationErrors.folio_deposito" />
              -->
                <validation-error class="col-12" :errors="apiValidationErrors.monto" />
                <validation-error class="col-12" :errors="apiValidationErrors.efectivo_mxn" />
                <span class="col-12 text-right"><strong>Acumulado de pagos: ${{calculateAcumuladoReserva}}</strong></span>
              </div>
              <input type="hidden" class="new-event--start"/>
              <input type="hidden" class="new-event--end"/>
            </form>
            <template slot="footer">
              <button :disabled="payReservaLoading" type="submit" class="btn btn-default hover-apolo new-event--add" @click="pay('Confirmar Reserva')">Pagar</button>
              <button type="button" class="btn btn-primary hover-apolo ml-auto" :disabled="disabledCancelPay" @click="showPayConfirmarReservaModal = false, selectReservaValue = 'inicial'">Cancelar</button>
            </template>
          </modal>
          <!-- MODAL ANULACION DE RESERVA -->
          <modal :show.sync="showAnulaReservaModal" :hasParent="true" modal-classes="modal-primary" size="sm">
              <h6 slot="header" class="mb-0 modal-title">Anulación de reservas</h6>
              <form class="new-event--form">
                <span>¿Desea anular las reservaciones seleccionadas?</span>
                <br>
                <span>Se realizará un egreso por ${{calculateTotalDevolucionReserva}}</span>
                <input type="hidden" class="new-event--start"/>
                <input type="hidden" class="new-event--end"/>
              </form>
              <template slot="footer">
                <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="anulaReserva()">Aceptar</button>
                <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showAnulaReservaModal = false">Cancelar</button>
              </template>
          </modal>
          <!-- MODAL CONFIRMACION ANULACION DE RESERVA -->
          <modal :show.sync="showAnulaReservaConfirmacionModal" :hasParent="true" modal-classes="modal-primary" size="sm">
              <h6 slot="header" class="mb-0 modal-title">Confirmación de Anulación de reservas</h6>
              <form class="new-event--form">
                <span>Se han anulado las reservas de los boletos seleccionados<br>
                      Se ha registrado un egreso por ${{anularReserva.monto}}<br>
                      Favor de devolver este monto al pasajero.</span>
                <input type="hidden" class="new-event--start"/>
                <input type="hidden" class="new-event--end"/>
              </form>
              <template slot="footer">
                <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="showAnulaReservaConfirmacionModal = false, showAnulaReservaModal = false">Aceptar</button>
              </template>
          </modal>
          <!-- MODAL BOLETOS PAGO -->
          <modal v-if="boletos_reservados" :show.sync="showBoletosPagoModal" :hasParent="true" modal-classes="modal-primary" size="sm">
              <h6 slot="header" class="mb-0 modal-title">Boletos</h6>
              <form class="new-event--form" v-if="(boletos_reservados.length > 0)">
                <div v-for="boleto in boletos_reservados" :key="boleto.id">
                  <li>Boleto: {{boleto.id}}</li>
                  <li>PASAJERO: {{boleto.nombre_pasajero}}</li>
                  <li v-if="boleto.paradero_origen">Origen: {{boleto.paradero_origen}}</li>
                  <li v-if="boleto.paradero_destino">Destino: {{boleto.paradero_destino}}</li>
                  <li>Fecha viaje: {{boleto.fecha_salida | moment('DD-MM-YYYY')}}</li>
                  <li>Hora viaje: {{boleto.fecha_salida | moment('HH:mm')}}</li>
                  <li>Asiento: {{boleto.asiento+' / '}} 
                    <span v-if="(boleto.categoria_asiento_id === 1)">Básica</span>
                    <span v-if="(boleto.categoria_asiento_id === 2)">Ejecutiva</span>
                    <span v-if="(boleto.categoria_asiento_id === 3)">Confort</span>
                  </li>
                  <li>Subida: {{boleto.paradero_origen}}</li>
                  <li>Bajada: {{boleto.paradero_destino}}</li>
                  <li v-if="boleto.descuento_id">Descuento: {{boleto.descuento_id}}</li>
                  <li>Valor pasaje: {{boleto.monto_total_pagar}}</li>
                  <li>{{boleto.resumen_pago}}</li>
                  <li>Clave facturación: {{boleto.clave_facturacion}}</li>
                  <hr>
                  <li>www.apoloplatinum.mx</li>
                  <hr>
                </div>
                
                <input type="hidden" class="new-event--start"/>
                <input type="hidden" class="new-event--end"/>
                </form>
          
                <template slot="footer">
                  <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showBoletosPagoModal = false, showPayConfirmarReservaModal = false">Cerrar</button>
                </template>
          </modal>
          <!-- MODAL PAGO TARJETA CONFIRMAR RESERVA -->
          <modal :show.sync="showPagoConfirmaReservaTarjeta" :hasParent="true" modal-classes="modal-primary" size="sm">
              <h6 slot="header" class="mb-0 modal-title">Comunicando con terminal</h6>
              <form class="new-event--form">
                  <li>www.apoloplatinum.mx</li>
                <input type="hidden" class="new-event--start"/>
                <input type="hidden" class="new-event--end"/>
              </form>
              <template slot="footer">
                <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showPagoConfirmaReservaTarjeta = false, showPayConfirmarReservaModal = false">Cerrar</button>
              </template>
          </modal>
      </modal>
      <!-- MODAL PAGAR EQUIPAJE EXTRA -->
      <modal :show.sync="showPayEquipajeExtraModal" :hasParent="true" modal-classes="modal-primary" size="sm">
        <h6 v-if="(boleto_info != null)" slot="header" class="mt-0 modal-title">Pago de equipaje extra de boleto #{{boleto_info.id}}</h6>
        <form v-if="showPayEquipajeExtraModal" class="new-event--form mt-0">
          <div class="row">
            <span class="col-7">Cantidad de piezas:</span>
            <select class="form-control col-2" v-model="equipajeExtra.cantidad_piezas">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
            </select>
            <br>
            <span class="col-6">Total a pagar: $</span>
            <div class="col-4 text-right">
              <ValidationProvider name="Total a pagar" rules="numeric" v-slot="{ errors }">
                <base-input
                  v-model="equipajeExtra.monto"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>
            </div>
            <span class="col-12">Métodos de pago</span>
            <base-checkbox class="col-9 ml-3" v-model="equipajeExtra.efectivo" :disabled="equipajeExtra.pago_tarjeta">
              Efectivo
            </base-checkbox>
            <span class="col-12 text-right">Cantidad restante a pagar MXN <strong>${{calculateRestanteEquipaje}}</strong></span>
            <span class="col-8 text-right">Se paga con MXN</span>
            <ValidationProvider class="col-4 text-right" name="Cantidad MXN" rules="integer:0,100000" v-slot="{ errors }">
              <base-input
                :disabled="equipajeExtra.pago_tarjeta"
                placeholder="Cantidad"
                v-model="equipajeExtra.efectivo_mxn"
              />
              <validation-error :errors="errors" />
            </ValidationProvider>
            <!--
            <span class="col-8 text-right">Se paga con USD</span>
            <ValidationProvider class="col-4 text-right" name="cantidad USD" rules="integer:0,100000" v-slot="{ errors }">
              <base-input
                placeholder="Cantidad"
                v-model="equipajeExtra.efectivo_usd"
              />
              <validation-error :errors="errors" />
            </ValidationProvider>
            <span class="col-12 text-right">Tipo de cambio: ${{tasa_usd_mxn}} En pesos: ${{tasa_usd_mxn * equipajeExtra.efectivo_usd}}</span>
            -->
            <span class="col-12 text-right">Cambio: ${{calculateCambioEquipaje}}</span>

            <base-checkbox class="col-9 ml-3" v-model="equipajeExtra.pago_tarjeta" :disabled="equipajeExtra.efectivo">
              Tarjeta
            </base-checkbox>
            <pulse-loader class="text-center col-12" v-if="loadingSpinner" :loading="loadingSpinner" :color="color" :size="size"></pulse-loader>
            <div v-else class="col-12">
              <p v-if="mensaje_pago_tarjeta != null" class="col-12" style="color: green !important; margin-left: -15px !important;">{{ mensaje_pago_tarjeta }}</p>
              <p v-if="mensaje_error_pago_tarjeta != null" class="col-12" style="color: red !important; margin-left: -15px !important;">{{ mensaje_error_pago_tarjeta }}</p>
              <div style="margin-top: -20px !important;">
                <ValidationProvider class="col-12" name="cantidad a pagar con tarjeta" rules="integer:1,100000" v-slot="{ errors }">
                  <base-input v-if="equipajeExtra.pago_tarjeta"
                    disabled
                    placeholder="Cantidad a pagar"
                    v-model="equipajeExtra.tarjeta"
                  />
                  <validation-error :errors="errors" />
                </ValidationProvider>
              </div>
              <div style="margin-top: -20px !important;">
                <base-input v-if="equipajeExtra.pago_tarjeta"
                  disabled
                  placeholder="Folio tarjeta"
                  v-model="equipajeExtra.folio_tarjeta"
                />
                <validation-error :errors="apiValidationErrors.folio_tarjeta" />
              </div>
            </div>
            <!--
            <base-checkbox class="col-9 ml-3" v-model="equipajeExtra.pago_deposito">
              Depósito a cuenta
            </base-checkbox>
            <ValidationProvider class="col-12" name="cantidad a pagar con deposito" rules="integer:1,100000" v-slot="{ errors }">
              <base-input v-if="equipajeExtra.pago_deposito"
                placeholder="Cantidad a pagar"
                v-model="equipajeExtra.deposito"
              />
              <validation-error :errors="errors" />
            </ValidationProvider>
            <ValidationProvider class="col-12" name="folio de pago con deposito" rules="numeric" v-slot="{ errors }">
              <base-input v-if="equipajeExtra.pago_deposito"
                placeholder="Folio deposito"
                v-model="equipajeExtra.folio_deposito"
              />
              <validation-error :errors="errors" />
            </ValidationProvider>
            <validation-error class="col-12" :errors="apiValidationErrors.folio_deposito" />
            -->
            <validation-error class="col-12" :errors="apiValidationErrors.monto" />
            <validation-error class="col-12" :errors="apiValidationErrors.efectivo_mxn" />
            <span class="col-12 text-right"><strong>Acumulado de pagos: ${{calculateAcumuladoEquipaje}}</strong></span>
          </div>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="pay('Equipaje Extra')">Pagar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" :disabled="disabledCancelPay" @click="showPayEquipajeExtraModal = false">Cancelar</button>
        </template>
        <!-- MODAL BOLETOS PAGO -->
        <modal v-if="(boleto_equipaje != null)" :show.sync="showBoletoEquipajeModal" :hasParent="true" modal-classes="modal-primary" size="sm">
          <h6 slot="header" class="mb-0 modal-title">Equipaje</h6>
          <form class="new-event--form" v-if="(boletos_reservados.length > 0)">
            <div>
              <li>Boleto: {{boleto_equipaje.boleto_id}}</li>
              <li>Cantidad: {{}}</li>
              <li>Monto: {{}}</li>
              <li>{{boleto_equipaje.resumen_pago}}</li>
              <li>Fecha: {{boleto_equipaje.created_at | moment('DD-MM-YYYY HH:mm:ss')}}</li>
              <li>Impreso por: {{}}</li>
              <hr>
              <li>www.apoloplatinum.mx</li>
              <hr>
            </div>
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
            </form>
  
            <template slot="footer">
              <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showBoletoEquipajeModal = false, showPayEquipajeExtraModal = false">Cerrar</button>
            </template>
        </modal>
      </modal>
      <!-- MODAL AUTORIZA CANJE BOLETO -->
      <modal :show.sync="showAutorizarCanjeBoletoModal" :hasParent="true" modal-classes="modal-primary" size="sm">
          <h6 slot="header" class="mb-0 modal-title">Autorizar canje después salida</h6>
          <form class="new-event--form" @submit.prevent="authCanjearBoleto">
            
            <base-input label="Token"
                        placeholder="Ingrese token"
                        v-model="auth.token"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.token"/>
            <!--
            <base-input label="Usuario"
                        placeholder="Ingrese usuario"
                        v-model="auth.usuario"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.usuario" />
            <base-input label="Contraseña"
                        placeholder="Ingrese contraseña"
                        v-model="auth.password"
                        type="password"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.password"/>
            <validation-error :errors="apiValidationErrors.permiso"/>
            -->
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
    
          <template slot="footer">
            <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="authCanjearBoleto">Autorizar</button>
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal()">Cancelar</button>
          </template>
      </modal>
      <!-- MODAL VENTA CANJE DE BOLETO -->
      <modal :show.sync="showVentaCanjeBoletoModal" :hasParent="true" modal-classes="modal-primary" size="xl">
        <h6 slot="header" class="mb-0 modal-title">Canje de boleto</h6>
        <form class="new-event--form" @submit.prevent="selectSubcorrida">
          <div class="row">
            <div class="col-12">
              <el-tabs v-model="activeTab" type="card">
                <!-- Canje de viaje -->
                <el-tab-pane label="Viaje" name="Viaje">
                  <div v-if="canjearBoleto.corrida_id">
                  <h3 class="mb-1">Corrida #{{canjearBoleto.corrida_id+': Subcorrida #'+canjearBoleto.id}}</h3>
                  <div v-if="canjearBoleto.tramo" class="row">
                    <div class="col-3">
                      <span>Terminal origen: {{canjearBoleto.tramo.terminal_origen.nombre}}</span>
                    </div>
                    <div class="col-4">
                      <span>Fecha salida: {{canjearBoleto.fecha_salida | moment('DD-MM-YYYY')}}</span>
                    </div>
                    <div class="col-2">
                      <base-button class="hover-apolo" type="default" icon size="sm" @click="listaAbordajeModal(canjearBoleto.corrida_id)">
                        <span class="btn-inner--text">Lista de abordaje</span>
                      </base-button>
                    </div>
                    <div class="col-3">
                      <base-button class="hover-apolo" type="default" icon size="sm" @click="showSeleccionSubcorridaModal = true">
                          <span class="btn-inner--text">Cambiar fecha de salida</span>
                        </base-button>
                    </div>
                  </div>
                  <div v-if="canjearBoleto.tramo" class="row mb-1">
                    <div class="col-3">
                      <span>Terminal destino: {{canjearBoleto.tramo.terminal_destino.nombre}}</span>
                    </div>
                    <div class="col-4">
                      <span>Hora de salida: {{canjearBoleto.fecha_salida | moment('HH:mm')}}</span>
                    </div>
                  </div>
                  <div v-if="canjearBoleto.niveles" class="col-12 mt-3">
                    <label v-if="parseInt(canjearBoleto.niveles) === 2">&nbsp;&nbsp;&nbsp;Estas en el nivel:&nbsp;{{nivelActual}}</label>
                    <!--INICIA SLIDER DE ASIENTOS-->
                    <div v-show="mostrarNivelUno">
                      <div v-for="(column,indexColumn) in canjearBoleto.estructura[0]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                        <box-item-canje 
                          :payment_details="payment_details"
                          :token_id="token_id"
                          :canjearBoleto="canjearBoleto"
                          :addDetail="addDetail"
                          :showPayCanjeTicketModal="showPayCanjeTicketModal"
                          :ref="'item'+(indexColumn).toString()+indexFila"
                          :id="'item'+(indexColumn).toString()+indexFila"
                          v-model="canjearBoleto.estructura[0][indexColumn][indexFila]" 
                          v-for="(fila,indexFila) in column" :key="canjearBoleto.corrida_id+canjearBoleto.id+(indexColumn).toString()+indexFila"
                        ></box-item-canje>
                      </div>
                    </div>
                    <div v-show="mostrarNivelDos">
                      <div v-show="parseInt(canjearBoleto.niveles) === 2" class="col-12">
                        <div v-for="(column,indexColumn) in canjearBoleto.estructura[1]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                          <box-item-canje 
                            :payment_details="payment_details"
                            :token_id="token_id"
                            :canjearBoleto="canjearBoleto"
                            :addDetail="addDetail" 
                            :showPayCanjeTicketModal="showPayCanjeTicketModal"
                            :ref="'item'+(indexColumn).toString()+indexFila"
                            :id="'item'+(indexColumn).toString()+indexFila"
                            v-model="canjearBoleto.estructura[1][indexColumn][indexFila]" 
                            v-for="(fila,indexFila) in column" :key="canjearBoleto.corrida_id+canjearBoleto.id+(indexColumn).toString()+indexFila"
                          ></box-item-canje>
                        </div>
                      </div>
                    </div>
                    <br>
                    <div v-if="parseInt(canjearBoleto.niveles) === 2" class="App__basic-example-controls text-center">
                      <button class="btn btn-default hover-apolo" @click.prevent="nivelUno()">
                        &laquo; Nivel 1
                      </button>
                      <button class="btn btn-default hover-apolo" @click.prevent="nivelDos()">
                        Nivel 2 &raquo;
                      </button>
                    </div>
                  </div>
                  <div v-if="canjearBoleto.paraderos_ida && canjearBoleto.paraderos_vuelta" class="row mt-3">
                    <span class="col-1" style="font-size: 13px !important;">Subida:</span>
                    <multiselect class="col-2" v-model="canjearBoleto.subida" :options="canjearBoleto.paraderos_ida" :searchable="false" :close-on-select="true" :showLabels="false" :preselect-first="true" placeholder="Selecccione paradero" open-direction="top"></multiselect>
                    <span class="col-1" style="font-size: 13px !important;">Bajada:</span>
                    <multiselect class="col-2" v-model="canjearBoleto.bajada" :options="canjearBoleto.paraderos_vuelta" :searchable="false" :close-on-select="true" :showLabels="false" :preselect-first="true" placeholder="Selecccione paradero" open-direction="top"></multiselect>
                    <div v-if="canjearBoleto.precios.length === 1">
                      <base-button v-if="canjearBoleto.precios[0].disponible === 1 && canjearBoleto.precios[0].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                        <span class="btn-inner--text">Blanco Básica</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[0].disponible === 1 && canjearBoleto.precios[0].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                        <span class="btn-inner--text">Blanco Ejecutiva</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[0].disponible === 1 && canjearBoleto.precios[0].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                        <span class="btn-inner--text">Blanco Confort</span>
                      </base-button>
                    </div>
                    <div v-if="canjearBoleto.precios.length === 2">
                      <base-button v-if="canjearBoleto.precios[0].disponible === 1 && canjearBoleto.precios[0].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                        <span class="btn-inner--text">Blanco Básica</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[0].disponible === 1 && canjearBoleto.precios[0].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                        <span class="btn-inner--text">Blanco Ejecutiva</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[0].disponible === 1 && canjearBoleto.precios[0].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                        <span class="btn-inner--text">Blanco Confort</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[1].disponible === 1 && canjearBoleto.precios[1].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                        <span class="btn-inner--text">Blanco Básica</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[1].disponible === 1 && canjearBoleto.precios[1].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                        <span class="btn-inner--text">Blanco Ejecutiva</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[1].disponible === 1 && canjearBoleto.precios[1].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                        <span class="btn-inner--text">Blanco Confort</span>
                      </base-button>
                    </div>
                    <div v-if="(canjearBoleto.precios.length === 3)">
                      <base-button v-if="canjearBoleto.precios[0].disponible === 1 && canjearBoleto.precios[0].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                        <span class="btn-inner--text">Blanco Básica</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[0].disponible === 1 && canjearBoleto.precios[0].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                        <span class="btn-inner--text">Blanco Ejecutiva</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[0].disponible === 1 && canjearBoleto.precios[0].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                        <span class="btn-inner--text">Blanco Confort</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[1].disponible === 1 && canjearBoleto.precios[1].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                        <span class="btn-inner--text">Blanco Básica</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[1].disponible === 1 && canjearBoleto.precios[1].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                        <span class="btn-inner--text">Blanco Ejecutiva</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[1].disponible === 1 && canjearBoleto.precios[1].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                        <span class="btn-inner--text">Blanco Confort</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[2].disponible === 1 && canjearBoleto.precios[2].categoria_asiento_id === 1" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoPrimera()">
                        <span class="btn-inner--text">Blanco Básica</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[2].disponible === 1 && canjearBoleto.precios[2].categoria_asiento_id === 2" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoEjecutiva()">
                        <span class="btn-inner--text">Blanco Ejecutiva</span>
                      </base-button>
                      <base-button v-if="canjearBoleto.precios[2].disponible === 1 && canjearBoleto.precios[2].categoria_asiento_id === 3" class="hover-apolo ml-1" type="primary" size="sm" @click="addBlancoConfort()">
                        <span class="btn-inner--text">Blanco Confort</span>
                      </base-button>
                    </div>
                  </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <!--ARRAY LISTA DE BOLETOS-->
          <div v-if="canjearBoleto && boleto_info" class="row mt-3 ml-1">
            <span>Boletos en canje:</span>
            <div style="overflow-x: scroll; width: auto;">
              <table class="table table-responsive table-flush">
                <thead>
                  <tr>
                    <th></th>
                    <th>Asiento</th>
                    <th style="min-width: 250px; padding:auto;">Nombre</th>
                    <th style="min-width: 110px; padding:auto;">Edad</th>
                    <th style="min-width: 200px; padding:auto;">Descuento</th>
                    <th>Precio Lista</th>
                    <th>Descuento</th>
                    <th>Pagado canje</th>
                    <th>Precio final</th>
                  </tr>
                </thead>
                <tbody v-if="payment_details.length">
                  <tr v-for="(detail,index) in payment_details" :key="detail.id">
                    <td>
                      <span>{{detail.tipo_viaje}}</span>
                      <button @click="deleteDetail(index)" type="button" class="btn btn-danger btn-sm">
                        Borrar
                      </button>
                    </td>
                    <td>
                      <button @click="changeDetail(index)" :class="detail.classActive ? 'btn-success' : 'btn-default'" type="button" class="btn btn-sm">
                        {{detail.asiento}}
                      </button>
                    </td>
                    <td>
                      <base-input
                        disabled
                        placeholder="Nombre completo"
                        v-model="detail.nombre_pasajero">
                      </base-input>
                    </td>
                    <td>
                      <ValidationProvider name="edad" rules="integer|between:1,120" v-slot="{ errors }">
                        <base-input
                          disabled
                          placeholder="Edad"
                          v-model="detail.edad">
                        </base-input>
                        <validation-error :errors="errors" />
                      </ValidationProvider>
                    </td>
                    <td>
                      <multiselect @select="checkDescuento($event, index)" v-model="detail.descuento" :options="descuentos" open-direction="bottom" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione descuento" label="nombre" track-by="id" :showLabels="false"></multiselect>
                    </td>
                    <td>
                      <span v-if="detail.precio_taquilla">${{detail.precio_taquilla}}</span>
                    </td>
                    <td v-if="detail.descuento">
                      <span v-if="detail.descuento.valor === 0"></span>
                      <span v-else>{{Math.trunc(detail.descuento.valor)+' '+detail.descuento.tipo_valor}}</span>
                    </td>
                    <td>
                      <span v-if="boleto_info.suma_movimientos">${{calculatePagosRecibidos}}</span>
                    </td>
                    <td>
                      <span v-if="detail.precio_taquilla">${{detail.monto_total_pagar = calculateFinal(index).toFixed(2)}}</span>
                    </td>
                  </tr>
                  <tr style="background-color: #CEECF5;">
                    <td colspan="8" align="right"><strong>Total:</strong></td>
                    <td>${{canjearBoleto.pago_total = calculateTotal}}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="6">
                      No hay boletos agregados
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="validacionEdad" class="mt-3 text-left">
            <span style="color: red">No hay un solo adulto en los boletos en venta. Es necesario informar que se necesita una carta responsiva para cada menor durante el abordaje.</span><a href="https://importare.mx" target="_blank" style="color:#0068a0 !important"> Abrir carta</a>
          </div>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
        <template slot="footer">
          <div class="text-right">
            <base-button class="hover-apolo mt-2" type="primary" size="lg" @click="cerrarCanje()">
              <span class="btn-inner--text">Cancelar</span>
            </base-button>
            <base-button v-if="payment_details.length" class="hover-apolo" type="default" size="lg" @click="validateTickets()">
              <span class="btn-inner--text">Finalizar canje</span>
            </base-button>
          </div>
          <!--<button v-if="activeTab === 'Vuelta'" type="button" class="btn btn-primary hover-apolo ml-auto" @click="showVentaCanjeBoletoModal =">Cancelar</button>-->
        </template>
        <!-- MODAL Componente Selección de Subcorrida -->
        <modal :show.sync="showSeleccionSubcorridaModal" :hasParent="true" modal-classes="modal-primary" size="xl">
          <form class="new-event--form" @submit.prevent="selectSubcorrida">
            <div class="row">
              <div class="col-4">
                <base-input label="Fecha">
                <date-picker
                  v-model="subcorrida.fecha_salida"
                  :format="'DD-MM-YYYY'"
                  :lang="'es'"
                ></date-picker>
                </base-input>
                <validation-error :errors="apiValidationErrors.fecha_salida" />
                <span v-if="validacion_fecha_salida != null">
                  <small class="argon-error" v-text="validacion_fecha_salida"/>
                </span>
              </div>
              <div class="col-5">
                <base-input label="Terminal Origen">
                  <multiselect v-model="subcorrida.terminal_origen" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione origen" :custom-label="nombreAbreviatura" track-by="id" :showLabels="false"></multiselect>
                </base-input>
                <validation-error :errors="apiValidationErrors.terminal_origen_id" />
              </div>
              <div class="col-2 mt-6">
                <button type="button" class="btn btn-default ml-auto hover-apolo" @click="Intercambiar()">Intercambiar</button>
              </div>
            </div>
            <div class="row">
              <div class="col-4"></div>
              <base-input class="col-5" label="Terminal Destino">
                <multiselect v-model="subcorrida.terminal_destino" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione destino" :custom-label="nombreAbreviatura" track-by="id" :showLabels="false"></multiselect>
              </base-input>
              <validation-error :errors="apiValidationErrors.terminal_destino_id" />
              <div class="col-3"></div>
            </div>
            <br>
            <span>Subcorridas:</span>
            <br>
            <el-table
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="subcorridas"
                @sort-change="sortChange"
                highlight-current-row
                @current-change="handleCurrentChange"
              >
                <div slot="empty" v-if="loading">
                  <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                </div>

                <div slot="empty" v-if="subcorridas">
                  Sin datos disponibles
                </div>
    
                <el-table-column label="# Corrida">
                  <div style="cursor: pointer;" slot-scope="{ row }" class="table-actions">
                    <span>{{row.attributes.corrida_id}}</span>
                  </div>
                </el-table-column>
                <el-table-column label="Fecha">
                  <div style="cursor: pointer;" slot-scope="{ row }">
                    <span>{{row.attributes.fecha_salida | moment('DD-MM-YYYY')}}</span>
                  </div>
                </el-table-column>
                <el-table-column label="Hora">
                  <div style="cursor: pointer;" slot-scope="{ row }">
                    <span>{{row.attributes.fecha_salida | moment('HH:mm')}}</span>
                  </div>
                </el-table-column>
                <el-table-column label="Día">
                  <div style="cursor: pointer;" slot-scope="{ row }">
                    <span>{{row.attributes.dia}}</span>
                  </div>
                </el-table-column>
                <el-table-column label="Origen">
                  <div style="cursor: pointer;" slot-scope="{ row }">
                    <span>{{row.attributes.tramo.terminal_origen.nombre +'('+ row.attributes.tramo.terminal_origen.abreviatura+')'}}</span>
                  </div>
                </el-table-column>
                <el-table-column label="Destino">
                  <div style="cursor: pointer;" slot-scope="{ row }">
                    <span>{{row.attributes.tramo.terminal_destino.nombre +'('+ row.attributes.tramo.terminal_destino.abreviatura+')'}}</span>
                  </div>
                </el-table-column>
                <el-table-column label="Disponibilidad">
                  <div style="cursor: pointer;" slot-scope="{ row }">
                    <span v-if="row.attributes.disponibilidad.B > 0">{{row.attributes.disponibilidad.B+'B'}}<span v-if="row.attributes.disponibilidad.E > 0">, </span></span>
                  <span v-if="row.attributes.disponibilidad.E > 0">{{row.attributes.disponibilidad.E+'E'}}<span v-if="row.attributes.disponibilidad.C > 0">, </span></span>
                    <span v-if="row.attributes.disponibilidad.C > 0">{{row.attributes.disponibilidad.C+'C'}}</span>
                  </div>
                </el-table-column>
              </el-table>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center flex-wrap"
            >
            <br>
              <base-pagination
                class="pagination-no-border"
                v-model="pagination_subcorridas.currentPage"
                :per-page="pagination_subcorridas.perPage"
                :total="total_subcorridas"
              />
            </div>
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
          <template slot="footer">
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showSeleccionSubcorridaModal = false, showVentaCanjeBoletoModal = false">Cancelar</button>
          </template>
        </modal>
        <!-- MODAL VER LISTA DE ABORDAJE -->
        <modal :show.sync="showListaAbordajeModal" :close-on-backdrop="true" :hasParent="true" modal-classes="modal-primary" size="lg">
          <div class="row">
            <h6 slot="header" class="mb-0 modal-title col-6">Lista de abordaje de corrida</h6>
            <button class="btn btn-default hover-apolo new-event--add ml-2 col-4" align="right" @click="imprimirLista()">Imprimir</button>
          </div>
          <form class="new-event--form">
            <span v-if="TotalVentaCorrida != null">Total de venta corrida: ${{ TotalVentaCorrida }}</span>
            <br>
            <el-table
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="listaAbordaje"
                @sort-change="sortChange"
              >
                <div slot="empty" v-if="loading">
                  <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                </div>
    
                <div slot="empty" v-if="listaAbordaje">
                  Sin datos disponibles
                </div>
    
                <el-table-column label="Asiento" prop="attributes.numero" width="100px"/>
                <el-table-column label="Categoría" prop="attributes.categoria.nombre" width="150px"/>
                <el-table-column label="Pasajero">
                    <div slot-scope="{ row }" class="table-actions">
                    <div v-if="row.attributes.pasajeros">
                        <div v-for="(pasajero, index) in row.attributes.pasajeros" :key="pasajero.id">
                        <span>{{pasajero}}</span> 
                        </div>
                    </div>
                    <div v-else>
                        <span>Sin Boletos</span>
                    </div>
                    </div> 
                </el-table-column>
                <el-table-column label="Sube">
                    <div slot-scope="{ row }" class="table-actions">
                    <div v-if="row.attributes.pasajeros">
                        <div v-for="(pasajero, index) in row.attributes.pasajeros" :key="pasajero.id">
                        <span>{{ row.attributes.sube[index] }}</span> 
                        </div>
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                    </div> 
                </el-table-column>
                <el-table-column label="Baja">
                    <div slot-scope="{ row }" class="table-actions">
                    <div v-if="row.attributes.pasajeros">
                        <div v-for="(pasajero, index) in row.attributes.pasajeros" :key="pasajero.id">
                        <span>{{ row.attributes.baja[index] }}</span> 
                        </div>
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                    </div> 
                </el-table-column>
                <el-table-column label="Valor Boleto">
                    <div slot-scope="{ row }" class="table-actions">
                    <div v-if="row.attributes.valor_venta_boleto">
                        <div v-for="(valor, index) in row.attributes.valor_venta_boleto" :key="valor.id">
                        <span>{{valor}}</span> 
                        </div>
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                    </div> 
                </el-table-column>
                <el-table-column label="Descuento">
                <div slot-scope="{ row }" class="table-actions">
                    <div v-if="row.attributes.detalles_descuento">
                        <div v-for="(valor, index) in row.attributes.detalles_descuento" :key="valor.id">
                        <span>{{valor}}</span> 
                        </div>
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                    </div> 
                </el-table-column>
            </el-table>
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
    
          <template slot="footer">
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showListaAbordajeModal = false">Cerrar</button>
          </template>
        </modal>
        <!-- MODAL AUTORIZA PAGO CON DESCUENTO -->
        <modal :show.sync="showAutorizaPagoDescuentoModal" :hasParent="true" modal-classes="modal-primary" size="sm">
          <h6 slot="header" class="mb-0 modal-title">Autorizar pago con descuento</h6>
          <form class="new-event--form" @submit.prevent="authPagoDescuento">
            <base-input label="Token"
                        placeholder="Ingrese token"
                        v-model="auth.token"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.token"/>
            <!--
            <base-input label="Usuario"
                        placeholder="Ingrese usuario"
                        v-model="auth.usuario"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.usuario" />
            <base-input label="Contraseña"
                        placeholder="Ingrese contraseña"
                        v-model="auth.password"
                        type="password"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.password"/>
            <validation-error :errors="apiValidationErrors.permiso"/>
            -->
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
    
          <template slot="footer">
            <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="authPagoDescuento">Autorizar</button>
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showAutorizaPagoDescuentoModal = false, showPayCanjeTicketModal = false">Cancelar</button>
          </template>
        </modal>
        <!-- MODAL AUTORIZA CANJE SIN PAGO -->
        <modal :show.sync="showAutorizaCanjeSinPagoModal" modal-classes="modal-primary" size="sm">
          <h6 slot="header" class="mb-0 modal-title">Autorizar canje sin pago</h6>
          <form class="new-event--form" @submit.prevent="authCanjeSinPago">
            <base-input label="Token"
                        placeholder="Ingrese token"
                        v-model="auth.token"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.token"/>
            <!--
            <base-input label="Usuario"
                        placeholder="Ingrese usuario"
                        v-model="auth.usuario"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.usuario" />
            <base-input label="Contraseña"
                        placeholder="Ingrese contraseña"
                        v-model="auth.password"
                        type="password"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.password"/>
            <validation-error :errors="apiValidationErrors.permiso"/>
            -->
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
    
          <template slot="footer">
            <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="authCanjeSinPago">Autorizar</button>
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showAutorizaCanjeSinPagoModal = false, showPayCanjeTicketModal = false">Cancelar</button>
          </template>
        </modal>
        <!-- MODAL PAGAR CANJE -->
        <modal :show.sync="showPayCanjeTicketModal" :hasParent="true" modal-classes="modal-primary" size="sm">
          <h6 slot="header" class="mb-0 modal-title">Total a pagar: ${{canjearBoleto.pago_total}}</h6>
          <form v-if="showPayCanjeTicketModal" class="new-event--form mt-0">
            <div class="row">
              <base-input
                class="col-12"
                placeholder="Correo electrónico"
                v-model="canjearBoleto.email"
                @input="canjearBoleto.email = canjearBoleto.email.trim().toLowerCase()"
              />
              <validation-error class="col-12" :errors="apiValidationErrors.email" />
              <base-input
                class="col-12"
                placeholder="Telefono"
                v-model="canjearBoleto.telefono"
                @input="canjearBoleto.telefono = canjearBoleto.telefono.replace(/\D/g, '')"
              />
              <validation-error class="col-12" :errors="apiValidationErrors.telefono" />
              <br>
              <span class="col-12">Métodos de pago</span>
              <base-checkbox class="col-9 ml-3" v-model="canjearBoleto.efectivo" :disabled="canjearBoleto.pago_tarjeta">
                Efectivo
              </base-checkbox>
              <span class="col-12 text-right">Cantidad restante a pagar MXN <strong>${{calculateRestante}}</strong></span>
              <span class="col-8 text-right">Se paga con MXN</span>
              <ValidationProvider class="col-4 text-right" name="Cantidad MXN" rules="integer:0,100000" v-slot="{ errors }">
                <base-input
                  :disabled="canjearBoleto.pago_tarjeta"
                  placeholder="Cantidad"
                  v-model="canjearBoleto.efectivo_mxn"
                />
                <validation-error class="col-12" :errors="errors" />
              </ValidationProvider>
              <!--
              <span class="col-8 text-right">Se paga con USD</span>
              <ValidationProvider class="col-4 text-right" name="cantidad USD" rules="integer:0,100000" v-slot="{ errors }">
                <base-input
                  placeholder="Cantidad"
                  v-model="canjearBoleto.efectivo_usd"
                />
                <validation-error class="col-12" :errors="errors" />
              </ValidationProvider>
              <span class="col-12 text-right">Tipo de cambio: ${{tasa_usd_mxn}} En pesos: ${{tasa_usd_mxn * canjearBoleto.efectivo_usd}}</span>
              -->
              <span class="col-12 text-right">Cambio: ${{calculateCambio}}</span>

              <base-checkbox class="col-9 ml-3" v-model="canjearBoleto.pago_tarjeta" :disabled="canjearBoleto.efectivo">
                Tarjeta
              </base-checkbox>
              <pulse-loader class="text-center col-12" v-if="loadingSpinner" :loading="loadingSpinner" :color="color" :size="size"></pulse-loader>
              <div v-else class="col-12">
                <p v-if="mensaje_pago_tarjeta != null" class="col-12" style="color: green !important; margin-left: -15px !important;">{{ mensaje_pago_tarjeta }}</p>
                <p v-if="mensaje_error_pago_tarjeta != null" class="col-12" style="color: red !important; margin-left: -15px !important;">{{ mensaje_error_pago_tarjeta }}</p>
                <div style="margin-top: -20px !important;">
                  <ValidationProvider class="col-12" name="cantidad a pagar con tarjeta" rules="integer:1,100000" v-slot="{ errors }">
                    <base-input v-if="canjearBoleto.pago_tarjeta"
                      disabled
                      placeholder="Cantidad a pagar"
                      v-model="canjearBoleto.tarjeta"
                    />
                    <validation-error :errors="errors" />
                  </ValidationProvider>
                </div>
                <div style="margin-top: -20px !important;">
                  <base-input v-if="canjearBoleto.pago_tarjeta"
                    disabled
                    placeholder="Folio tarjeta"
                    v-model="canjearBoleto.folio_tarjeta"
                  />
                  <validation-error :errors="apiValidationErrors.folio_tarjeta" />
                </div>
              </div>
              <!--
              <base-checkbox class="col-9 ml-3" v-model="canjearBoleto.pago_deposito">
                Depósito a cuenta
              </base-checkbox>
              <ValidationProvider class="col-12" name="cantidad a pagar con deposito" rules="integer:1,100000" v-slot="{ errors }">
                <base-input v-if="canjearBoleto.pago_deposito"
                  placeholder="Cantidad a pagar"
                  v-model="canjearBoleto.deposito"
                />
                <validation-error class="col-12" :errors="errors" />
              </ValidationProvider>
              <ValidationProvider class="col-12" name="folio de pago con deposito" rules="numeric" v-slot="{ errors }">
                <base-input v-if="canjearBoleto.pago_deposito"
                  placeholder="Folio deposito"
                  v-model="canjearBoleto.folio_deposito"
                />
                <validation-error class="col-12" :errors="errors" />
              </ValidationProvider>
              <validation-error :errors="apiValidationErrors.folio_deposito" />
            -->
              <validation-error class="col-12" :errors="apiValidationErrors.monto" />
              <validation-error class="col-12" :errors="apiValidationErrors.efectivo_mxn" />
              <span class="col-12 text-right"><strong>Acumulado de pagos: ${{calculateAcumulado}}</strong></span>
              <validation-error class="col-12" :errors="apiValidationErrors.monto" />
            </div>
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
          <template slot="footer">
            <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="pay('Canjear Boleto')">Pagar</button>
            <button type="button" class="btn btn-primary hover-apolo ml-auto" :disabled="disabledCancelPay" @click="showPayCanjeTicketModal = false">Cancelar</button>
          </template>
        </modal>
        <!-- MODAL LIQUIDAR CANJE -->
        <modal :show.sync="showCanjeLiquidarModal" :hasParent="true" modal-classes="modal-primary" size="sm">
          <h6 slot="header" class="mb-0 modal-title">Canje con diferencia a pagar</h6>
          <form class="new-event--form">
            <span v-if="boleto_info != null">Se tiene una diferencia a pagar de ${{calculateTotal}}</span>
            <br>
            <span>¿Qué se hace con esta diferencia?</span>
            <br>
            <div class="row ml-2">
              <base-checkbox class="col-5" v-model="canjearBoleto.se_cobra">
                  Se cobra
              </base-checkbox>
              <base-checkbox class="col-6" v-model="canjearBoleto.no_se_cobra">
                  No se cobra
              </base-checkbox>
            </div>
            <div class="row mt-2 ml-2">
              <base-input v-if="canjearBoleto.no_se_cobra && !canjearBoleto.se_cobra" v-model="canjearBoleto.motivo_no_se_cobra" placeholder="Escriba un motivo"></base-input>
            </div>
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
          <template slot="footer">
            <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="canjeLiquidar()">Continuar</button>
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showCanjeLiquidarModal = false">Cancelar</button>
          </template>
        </modal>
        <!-- MODAL DEVOLVER CANJE -->
        <modal :show.sync="showCanjeDevolverModal" :hasParent="true" modal-classes="modal-primary" size="sm">
          <h6 slot="header" class="mb-0 modal-title">Canje con diferencia a devolver</h6>
          <form class="new-event--form">
            <span v-if="boleto_info != null">Se tiene una diferencia a devolver de ${{((calculateTotal) * (-1)).toFixed(2)}}</span>
            <br>
            <span>¿Qué se hace con esta diferencia?</span>
            <br>
            <div class="row ml-2">
              <base-checkbox class="col-5" v-model="canjearBoleto.se_devuelve">
                  Se devuelve
              </base-checkbox>
              <base-checkbox class="col-6" v-model="canjearBoleto.no_se_devuelve">
                  No se devuelve
              </base-checkbox>
            </div>
            <div class="row mt-2 ml-2">
              <base-input v-if="canjearBoleto.se_devuelve && !canjearBoleto.no_se_devuelve" v-model="canjearBoleto.motivo_se_devuelve" placeholder="Escriba un motivo"></base-input>
            </div>
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
          <template slot="footer">
            <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="canjeDevolver()">Continuar</button>
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showCanjeDevolverModal = false">Cancelar</button>
          </template>
          <!-- MODAL AUTORIZA CANJE CON DEVOLUCION -->
          <modal :show.sync="showAutorizaCanjeConDevolucionModal" :hasParent="true" modal-classes="modal-primary" size="sm">
            <h6 slot="header" class="mb-0 modal-title">Autorizar canje con devolución</h6>
            <form class="new-event--form" @submit.prevent="authCanjeConDevolucion">
              <base-input label="Token"
                        placeholder="Ingrese token"
                        v-model="auth.token"
                        input-classes="form-control-alternative new-event--title">
              </base-input>
              <validation-error :errors="apiValidationErrors.token"/>
              <!--
              <base-input label="Usuario"
                          placeholder="Ingrese usuario"
                          v-model="auth.usuario"
                          input-classes="form-control-alternative new-event--title">
              </base-input>
              <validation-error :errors="apiValidationErrors.usuario" />
              <base-input label="Contraseña"
                          placeholder="Ingrese contraseña"
                          v-model="auth.password"
                          type="password"
                          input-classes="form-control-alternative new-event--title">
              </base-input>
              <validation-error :errors="apiValidationErrors.password"/>
              <validation-error :errors="apiValidationErrors.permiso"/>
              -->
              <input type="hidden" class="new-event--start"/>
              <input type="hidden" class="new-event--end"/>
            </form>
      
            <template slot="footer">
              <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="authCanjeConDevolucion">Autorizar</button>
              <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showAutorizaCanjeConDevolucionModal = false, showPayCanjeTicketModal = false">Cancelar</button>
            </template>
          </modal>
        </modal>
        <!--MODAL BOLETOS CANJE -->
        <modal  :show.sync="showBoletoCanjeadoModal" :hasParent="true" modal-classes="modal-primary" size="sm">
          <h6 slot="header" class="mb-0 modal-title">Boleto canjeado</h6>
          <form class="new-event--form">
            <div>
              <li>Boleto: {{boletos_canje.id}}</li>
              <li>PASAJERO: {{boletos_canje.nombre_pasajero}}</li>
              <li v-if="boletos_canje.paradero_origen">Origen: {{boletos_canje.paradero_origen}}</li>
              <li v-if="boletos_canje.paradero_destino">Destino: {{boletos_canje.paradero_destino}}</li>
              <li>Fecha viaje: {{boletos_canje.fecha_salida | moment('DD-MM-YYYY')}}</li>
              <li>Hora viaje: {{boletos_canje.fecha_salida | moment('HH:mm')}}</li>
              <li>Asiento:
                <span v-if="(boletos_canje.asiento === null)">Blanco / </span>
                <span v-else>{{boletos_canje.asiento+' / '}} </span>
                <span v-if="(boletos_canje.categoria_asiento_id === 1)">Básica</span>
                <span v-if="(boletos_canje.categoria_asiento_id === 2)">Ejecutiva</span>
                <span v-if="(boletos_canje.categoria_asiento_id === 3)">Confort</span>
              </li>
              <li>Subida: {{boletos_canje.paradero_origen}}</li>
              <li>Bajada: {{boletos_canje.paradero_destino}}</li>
              <li v-if="boletos_canje.descuento">Descuento: {{boletos_canje.descuento.nombre}}</li>
              <li v-if="boletos_canje.cortesia_razon">Razón cortesía: {{boletos_canje.cortesia_razon}}</li>
              <li>Valor pasaje: {{boletos_canje.monto_total_pagar}}</li>
              <li>{{boletos_canje.resumen_pago}}</li>
              <li>Clave facturación: {{boletos_canje.clave_facturacion}}</li>
              <hr>
              <li>www.apoloplatinum.com.mx</li>
              <hr>
            </div>
            
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
    
          <template slot="footer">
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="reload()">Cerrar</button>
          </template>
        </modal>
      </modal>
    </modal>
  </div>
</template>
<script>
import Vue from 'vue';
import {Impresora} from "@/printer/Impresora.js";
import ImpresionCanje from "./ImpresionCanje.vue";
import ImpresionCanje2 from "./ImpresionCanje2.vue";
import ImpresionBoletosBlanco from "./ImpresionBoletosBlanco.vue";
import ComprobanteCanje from "./ComprobanteCanje.vue";
import ImpresionEquipajeExtra from "./ImpresionEquipajeExtra.vue";
import ImpresionListaAbordaje from "./ImpresionListaAbordaje.vue";
import ReImpresionBoletos from "./ReImpresionBoletos.vue";
import ReImpresionBoletos2 from "./ReImpresionBoletos2.vue";
import ImpresionAnular from "./ImpresionAnular.vue";
import { BasePagination, Modal } from "@/components/";
import {
  Tabs,
  TabPane,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  RadioButton,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
import Multiselect from 'vue-multiselect';
import BoxItemCanje from "./BoxItemCanje.vue";
import { ValidationProvider, ValidationObserver,
         extend } from 'vee-validate';
import { integer, numeric } from 'vee-validate/dist/rules';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
extend('integer:0,100000', { 
  ...integer 
});
extend('integer:1,100000', { 
  ...integer 
});

extend('numeric', { 
  ...numeric 
});
  
export default {
  layout: "DashboardLayout",

  components: {
    BoxItemCanje,
    DatePicker,
    ValidationProvider,
    ValidationObserver,
    ValidationError,
    Multiselect,
    Modal,
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    PulseLoader
  },

  mixins: [formMixin],

  data() {
    return {
      diferencia_devolver: false,
      diferencia_liquidar: false,
      validacionEdad: false,
      token_canje_despues_salida: null,
      boleto_reimpresion: null,
      selectReservaValue: 'inicial',
      boletos: [],
      boleto_info: null,
      boletos_reservados: [],
      boleto_equipaje: null,
      boletos_canje: [],
      token_id: null,
      terminales: [],
      tasa_usd_mxn: null,
      listaAbordaje: [],
      confirmarReserva: {
        type: "confirmar reserva",
        boletos: [],
        efectivo: true,
        efectivo_mxn: null,
        efectivo_usd: null,
        tarjeta: null,
        pago_tarjeta: false,
        folio_tarjeta: null,
        deposito: null,
        pago_deposito: false,
        folio_deposito: null,
        total_metodos: null,
        cambio: null,
        saldo_efectivo_mxn: null,
      },
      boletos_generados: [],
      anularReserva: {
        type: "anular reserva"
      },
      verBotonReserva: false,
      canjearBoleto: {
        paradero_origen: null,
        paradero_destino: null,
        bajada: null,
        subida: null,
        type: "canjear boleto",
        boleto_id: null,
        efectivo: true,
        efectivo_mxn: null,
        efectivo_usd: null,
        tarjeta: null,
        pago_tarjeta: false,
        folio_tarjeta: null,
        deposito: null,
        pago_deposito: false,
        folio_deposito: null,
        total_metodos: null,
        cambio: null,
        saldo_efectivo_mxn: null,
        monto: null,
        se_cobra: true,
        no_se_cobra: false,
        motivo_no_se_cobra: null,
        se_devuelve: false,
        no_se_devuelve: true,
        motivo_se_devuelve: null,
        token_descuento: null,
        token_canje_despues_salida: null,
        token_canje_sin_pago: null,
        token_canje_con_devolucion: null,
        es_pago_contado: null,
        email: null,
        telefono: null,
        agencia_id: null,
        diferencia: null,
        monto: null,
        boletos: [],
        motivo: null,
      },
      equipajeExtra: {
        type: "pago equipaje extra",
        boleto_id: null,
        efectivo: true,
        efectivo_mxn: null,
        efectivo_usd: null,
        tarjeta: null,
        pago_tarjeta: false,
        folio_tarjeta: null,
        deposito: null,
        pago_deposito: false,
        folio_deposito: null,
        total_metodos: null,
        cambio: null,
        saldo_efectivo_mxn: null,
        monto: null,
        cantidad_piezas: null
      },
      activeTab: 'Viaje',
      mostrarNivelUno: true,
      mostrarNivelDos: false,
      nivelActual: '1',
      vuelta: false,
      validacion_fecha_salida: null,
      subcorrida: {
        type: "subcorrida",
        fecha_salida: new Date(),
        hoy: new Date(),
        terminal_origen: null,
        terminal_destino: null,
        agencia: null,
      },
      subcorridas: [],
      payment_details: [],
      descuentos: [],
      mensaje_taquilla: null,
      selectedRows: [],
      query: null,
      type: null,
      filters: {
        types:[
        {value:'1', descripcion: '# de boleto'},
        {value:'2', descripcion: '# de corrida'},
        {value:'3', descripcion: 'Nombre de pasajero'}
      ]},
      permiso:{
        type: "verificar", 
        verificado: null
      },
      auth: {
        type: "autorizar",
        usuario: null,
        password: null,
        permiso: null,
        token: null
      },
      anularBoleto: {
        type: 'anular boleto',
        boleto_id: null,
        anulado_autorizado_por: null,
        agencia_id: null,
        motivo_anulado: null
      },
      reimprimirBoleto: {
        type: 'reimprimir boleto',
        boleto_id: null,
        reimpresion_autorizado_por: null,
        token: null
      },
      editarNombrePasajeroBoleto:{
        type: 'editar nombre',
        boleto_id: null,
        nombre_pasajero: null,
      },
      
      sort: "created_at",

      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [{value:'5', descripcion: '5 boletos por página'},
        {value:'10', descripcion: '10 boletos por página'},
        {value:'25', descripcion: '25 boletos por página'},
        {value:'50', descripcion: '50 boletos por página'}],
      },
      pagination_subcorridas: {
        perPage: 5,
        currentPage: 1,
      },
      total: 0,
      total_subcorridas: 0,
      loading: true,
      showVerBoletoModal: false,
      showCanjeBoletoModal: false,
      showAnularBoletoModal: false,
      showAutorizarAnularBoletoModal: false,
      showVerReservaModal: false,
      showVenderEquipajeModal: false,
      showEditarPasajeroModal: false,
      showAutorizarReimprimirBoletoModal: false,
      showPayConfirmarReservaModal: false,
      showPagoConfirmaReservaTarjeta: false,
      showBoletosPagoModal: false,
      showAnulaReservaModal: false,
      showAnulaReservaConfirmacionModal: false,
      showPayEquipajeExtraModal: false,
      showBoletoEquipajeModal: false,
      showAutorizarCanjeBoletoModal: false,
      showVentaCanjeBoletoModal: false,
      showSeleccionSubcorridaModal: false,
      showAutorizaPagoDescuentoModal: false,
      showAutorizaCanjeSinPagoModal: false,
      showAutorizaCanjeConDevolucionModal: false,
      showPayCanjeTicketModal: false,
      showBoletoCanjeadoModal: false,
      showCanjeLiquidarModal: false,
      showCanjeDevolverModal: false,
      showListaAbordajeModal: false,
      descuento_validacion: null,
      loadingSpinner: false,
      color: '#0068a0',
      size: '30px',
      mensaje_pago_tarjeta: null,
      mensaje_error_pago_tarjeta: null,
      disabledCancelPay: false,
      TotalVentaCorrida: null,
      payReservaLoading: false
    };
  },

  mounted(){
    //const date = new Date();
    //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    this.getOpciones();
    //this.getDescuentos();
  },

  computed: {
    calculateTotal: function(){
      var result=0.0;
      for(var i=0;i<this.payment_details.length;i++){
        if(this.payment_details[i] !== undefined){
          if(this.payment_details[i].descuento === undefined || this.payment_details[i].descuento === null){
            result = result + parseInt(this.payment_details[i].precio_taquilla);
          }else{
            if(this.payment_details[i].descuento.tipo_valor === '%'){
              result = result + (parseInt(this.payment_details[i].precio_taquilla) - ((this.payment_details[i].precio_taquilla) * (parseInt(this.payment_details[i].descuento.valor)/100)));
            }else{
              result = result + (parseInt(this.payment_details[i].precio_taquilla) - parseInt(this.payment_details[i].descuento.valor));
            }
          }
        }
      }
      return (result - this.calculatePagosRecibidos).toFixed(2);
    },

    calculateRestante: function(){
      var result = this.calculateTotal;
      if(this.canjearBoleto.efectivo_mxn){
        result = (result - Number(this.canjearBoleto.efectivo_mxn));
      }
      if(this.canjearBoleto.efectivo_usd){
        result = result - Number((this.tasa_usd_mxn * this.canjearBoleto.efectivo_usd));
      }
      if(this.canjearBoleto.tarjeta){
        result = result - Number(this.canjearBoleto.tarjeta);
      }
      if(this.canjearBoleto.deposito){
        result = result - Number(this.canjearBoleto.deposito);
      }
      if(result < 0){
        result = 0;
      }
      return result;
    },

    calculateCambio: function(){
      var result = 0.0;
      if(this.calculateRestante === 0){
        var result = this.calculateTotal;
        if(this.canjearBoleto.efectivo_mxn){
          result = result - Number(this.canjearBoleto.efectivo_mxn);
        }
        if(this.canjearBoleto.efectivo_usd){
          result = result - Number(this.tasa_usd_mxn * this.canjearBoleto.efectivo_usd);
        }
        if(this.canjearBoleto.pago_tarjeta){
          result = result - Number(this.canjearBoleto.tarjeta);
        }
        if(this.canjearBoleto.pago_deposito){
          result = result - Number(this.canjearBoleto.deposito);
        }
        if(result < 0){
          result = Math.abs(result);
        }
        return result.toFixed(2);
      }
      return result.toFixed(2);
    },

    calculateAcumulado: function(){
      var result = 0.0;
      if(this.canjearBoleto.efectivo_mxn){
        result = result + Number(this.canjearBoleto.efectivo_mxn);
      }
      if(this.canjearBoleto.efectivo_usd){
        var usd = this.tasa_usd_mxn * this.canjearBoleto.efectivo_usd;
        result = result + Number(usd);
      }
      if(this.canjearBoleto.tarjeta){
        result = result + Number(this.canjearBoleto.tarjeta);
      }
      if(this.canjearBoleto.deposito){
        result = result + Number(this.canjearBoleto.deposito);
      }
      return Number(result).toFixed(2);
    },
    
    calculatePagosRecibidos: function(){
      let total = 0;
      if(this.boleto_info != null){
        total = total + Number(this.boleto_info.suma_movimientos);
      }
      return total;
    },

    calculateTotalPagoReserva: function(){
        this.confirmarReserva.boletos = this.boletos_reservados.filter(item => item.selected == true);
        var result_abonado=0.0;
        var result_total=0.0;
        var result = 0.0;
        for(let i = 0; i < this.confirmarReserva.boletos.length; i++){
          result_abonado = result_abonado + Number(this.confirmarReserva.boletos[i].attributes.abonado);
          result_total = result_total + Number(this.confirmarReserva.boletos[i].attributes.monto_total_pagar);
        }
        if(result_total - result_abonado < 0){
          result = 0;
        }else{
          result = result_total - result_abonado
        }
        return result;
    },

    calculateTotalDevolucionReserva: function(){
        this.anularReserva.boletos = this.boletos_reservados.filter(item => item.selected == true);
        var result_abonado=0.0;
        for(let i = 0; i < this.anularReserva.boletos.length; i++){
          result_abonado = result_abonado + Number(this.anularReserva.boletos[i].attributes.abonado);
        }
        return result_abonado;
    },

    calculateRestanteReserva: function(){
      var result = this.calculateTotalPagoReserva;
      if(this.confirmarReserva.efectivo_mxn){
        result = (result - Number(this.confirmarReserva.efectivo_mxn));
      }
      if(this.confirmarReserva.efectivo_usd){
        result = result - Number((this.tasa_usd_mxn * this.confirmarReserva.efectivo_usd));
      }
      if(this.confirmarReserva.tarjeta){
        result = result - Number(this.confirmarReserva.tarjeta);
      }
      if(this.confirmarReserva.deposito){
        result = result - Number(this.confirmarReserva.deposito);
      }
      if(result < 0){
        result = 0;
      }
      return result;
    },

    calculateCambioReserva: function(){
      var result = 0.0;
      if(this.calculateRestanteReserva === 0){
        var result = this.calculateTotalPagoReserva;
        if(this.confirmarReserva.efectivo_mxn){
          result = result - Number(this.confirmarReserva.efectivo_mxn);
        }
        if(this.confirmarReserva.efectivo_usd){
          result = result - Number(this.tasa_usd_mxn * this.confirmarReserva.efectivo_usd);
        }
        if(this.confirmarReserva.pago_tarjeta){
          result = result - Number(this.confirmarReserva.tarjeta);
        }
        if(this.confirmarReserva.pago_deposito){
          result = result - Number(this.confirmarReserva.deposito);
        }
        if(result < 0){
          result = Math.abs(result);
        }
        return result.toFixed(2);
      }
      return result.toFixed(2);
    },

    calculateAcumuladoReserva: function(){
      var result = 0.0;
      if(this.confirmarReserva.efectivo_mxn){
        result = result + Number(this.confirmarReserva.efectivo_mxn);
      }
      if(this.confirmarReserva.efectivo_usd){
        var usd = this.tasa_usd_mxn * this.confirmarReserva.efectivo_usd;
        result = result + Number(usd);
      }
      if(this.confirmarReserva.tarjeta){
        result = result + Number(this.confirmarReserva.tarjeta);
      }
      if(this.confirmarReserva.deposito){
        result = result + Number(this.confirmarReserva.deposito);
      }
      return Number(result).toFixed(2);
    },

    calculateRestanteEquipaje: function(){
      var result = this.equipajeExtra.monto;
      if(this.equipajeExtra.efectivo_mxn){
        result = (result - Number(this.equipajeExtra.efectivo_mxn));
      }
      if(this.equipajeExtra.efectivo_usd){
        result = result - Number((this.tasa_usd_mxn * this.equipajeExtra.efectivo_usd));
      }
      if(this.equipajeExtra.tarjeta){
        result = result - Number(this.equipajeExtra.tarjeta);
      }
      if(this.equipajeExtra.deposito){
        result = result - Number(this.equipajeExtra.deposito);
      }
      if(result < 0){
        result = 0;
      }
      return result;
    },

    calculateCambioEquipaje: function(){
      var result = 0.0;
      if(this.calculateRestanteEquipaje === 0){
        var result = this.equipajeExtra.monto;
        if(this.equipajeExtra.efectivo_mxn){
          result = result - Number(this.equipajeExtra.efectivo_mxn);
        }
        if(this.equipajeExtra.efectivo_usd){
          result = result - Number(this.tasa_usd_mxn * this.equipajeExtra.efectivo_usd);
        }
        if(this.equipajeExtra.pago_tarjeta){
          result = result - Number(this.equipajeExtra.tarjeta);
        }
        if(this.equipajeExtra.pago_deposito){
          result = result - Number(this.equipajeExtra.deposito);
        }
        if(result < 0){
          result = Math.abs(result);
        }
        return result.toFixed(2);
      }
      return result.toFixed(2);
    },

    calculateAcumuladoEquipaje: function(){
      var result = 0.0;
      if(this.equipajeExtra.efectivo_mxn){
        result = result + Number(this.equipajeExtra.efectivo_mxn);
      }
      if(this.equipajeExtra.efectivo_usd){
        var usd = this.tasa_usd_mxn * this.equipajeExtra.efectivo_usd;
        result = result + Number(usd);
      }
      if(this.equipajeExtra.tarjeta){
        result = result + Number(this.equipajeExtra.tarjeta);
      }
      if(this.equipajeExtra.deposito){
        result = result + Number(this.equipajeExtra.deposito);
      }
      return Number(result).toFixed(2);
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    type: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    payment_details: {
      handler: "validateAge",
      immediate: false,
      deep: true,
    },
    boletos_reservados: {
      handler: "validateBoletosReserva",
      immediate: false,
      deep: true,
    },
    'selectReservaValue'() {
      if(this.selectReservaValue === 'confirmar' || this.selectReservaValue === 'anular'){
        this.selectReserva();
      }
    },
    'subcorrida.fecha_salida': {
      handler: "getListDebouncedSubcorridas",
      immediate: false,
    },
    'subcorrida.terminal_origen': {
      handler: "getListDebouncedSubcorridas",
      immediate: false,
    },
    'subcorrida.terminal_destino': {
      handler: "getListDebouncedSubcorridas",
      immediate: false,
    },
    'canjearBoleto.no_se_cobra': {
      handler: "changeNoSeCobra",
      immediate: true,
    },
    'canjearBoleto.se_cobra': {
      handler: "changeSeCobra",
      immediate: true,
    },
    'canjearBoleto.se_devuelve': {
      handler: "changeSeDevuelve",
      immediate: true,
    },
    'canjearBoleto.no_se_devuelve': {
      handler: "changeNoSeDevuelve",
      immediate: true,
    },
    'canjearBoleto.efectivo': {
      handler: "changeMetodoPago",
      immediate: true,
    },
    'canjearBoleto.pago_tarjeta': {
      handler: "changeMetodoPago",
      immediate: true,
    },
    'confirmarReserva.efectivo': {
      handler: "changeMetodoPago",
      immediate: true,
    },
    'confirmarReserva.pago_tarjeta': {
      handler: "changeMetodoPago",
      immediate: true,
    },
    'equipajeExtra.efectivo': {
      handler: "changeMetodoPago",
      immediate: true,
    },
    'equipajeExtra.pago_tarjeta': {
      handler: "changeMetodoPago",
      immediate: true,
    },
    
  },

  methods: {
    validateBoletosReserva(){
      for(let i = 0; i < this.boletos_reservados.length; i++){
        if(this.boletos_reservados[i].selected){
          this.selectReservaValue = 'inicial';
          break;
        }
      } 
    },
    changeMetodoPago(){
      if(this.canjearBoleto.efectivo === false){
        this.canjearBoleto.efectivo_mxn = null;
        this.canjearBoleto.efectivo_usd = null;
        this.canjearBoleto.efectivo_usd_mxn = null;
      }
      if(this.canjearBoleto.pago_tarjeta === false){
        this.canjearBoleto.tarjeta = null;
        this.canjearBoleto.folio_tarjeta = null;
        this.mensaje_error_pago_tarjeta = null;
      }
      else if(this.disabledCancelPay === false){
        this.canjearBoleto.tarjeta = 0;
        this.canjearBoleto.tarjeta = this.calculateRestante;
      }

      if(this.confirmarReserva.efectivo === false){
        this.confirmarReserva.efectivo_mxn = null;
        this.confirmarReserva.efectivo_usd = null;
        this.confirmarReserva.efectivo_usd_mxn = null;
      }
      if(this.confirmarReserva.pago_tarjeta === false){
        this.confirmarReserva.tarjeta = null;
        this.confirmarReserva.folio_tarjeta = null;
        this.mensaje_error_pago_tarjeta = null;
      }
      else if(this.disabledCancelPay === false){
        this.confirmarReserva.tarjeta = 0;
        this.confirmarReserva.tarjeta = this.calculateRestanteReserva;
      }
      
      if(this.equipajeExtra.efectivo === false){
        this.equipajeExtra.efectivo_mxn = null;
        this.equipajeExtra.efectivo_usd = null;
        this.equipajeExtra.efectivo_usd_mxn = null;
      }
      if(this.equipajeExtra.pago_tarjeta === false){
        this.equipajeExtra.tarjeta = null;
        this.equipajeExtra.folio_tarjeta = null;
        this.mensaje_error_pago_tarjeta = null;
      }
      else if(this.disabledCancelPay === false){
        this.equipajeExtra.tarjeta = 0;
        this.equipajeExtra.tarjeta = this.calculateRestanteEquipaje;
      }
    },
    telefonoValido() {
      return /^\d{10}$/.test(this.venta.telefono);
    },
    emailValido(){
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.venta.email);
    },
    pay(type){
      if(this.canjearBoleto.telefono){
        if (!this.telefonoValido()) {
          this.$notify({
              type: "danger",
              message: "El teléfono ingresado debe tener 10 dígitos",
              duration: -1
          });
          return;
        }
      }
      if(this.canjearBoleto.email){
        if (!this.emailValido()) {
          this.$notify({
              type: "danger",
              message: "El email ingresado no es valido",
              duration: -1
          });
          return;
        }
      }
      if((this.equipajeExtra.tarjeta != null  && this.equipajeExtra.tarjeta != '') || 
          (this.canjearBoleto.tarjeta != null && this.canjearBoleto.tarjeta != '') || 
          (this.confirmarReserva.tarjeta != null && this.confirmarReserva.tarjeta != '')){
        this.payTarjeta(type);
      }else{
        if(type === 'Equipaje Extra'){
          this.payEquipajeExtra();
        }else if(type === 'Canjear Boleto'){
          this.payCanjeTicket();
        }else{
          this.payReservaLoading = true;
          this.payConfirmaReserva();
        }
      }
    },
    async payTarjeta(type){
      this.loadingSpinner = true;
      //Nombre cajero y motivo
      let me = await this.$store.getters["profile/me"];
      let username = (me.attributes.username).substr(0, 6);
      
      let pinpad = new Impresora;
      //Fecha y hora
      let fecha = pinpad.parseDate(new Date());
      //Referencias y montos
      let referencia = '';
      let monto = '';
      if(type === 'Equipaje Extra'){
        referencia = 'EE-'+this.boleto_info.subcorrida_id+'-'+this.boleto_info.id+'-'+fecha;
        monto = this.equipajeExtra.tarjeta;
      }else if(type === 'Canjear Boleto'){
        referencia = 'CB-'+this.boleto_info.subcorrida_id+'-'+this.boleto_info.id+'-'+fecha;
        monto = this.canjearBoleto.tarjeta;
      }else{
        referencia = 'CR-'+this.boleto_info.subcorrida_id+'-'+this.boleto_info.venta_boleto_id+'-'+fecha;
        monto = this.confirmarReserva.tarjeta;
      }
      pinpad.autorizarPago(monto, username, referencia).then(respuesta => {
        if(respuesta.status === true){
          this.mensaje_error_pago_tarjeta = null;
          this.mensaje_pago_tarjeta = respuesta.mensaje;
          this.disabledCancelPay = true;
          this.loadingSpinner = false;
          if(type === 'Equipaje Extra'){
            this.equipajeExtra.folio_tarjeta = respuesta.autorizacion;
            this.payEquipajeExtra();
          }else if(type === 'Canjear Boleto'){
            this.canjearBoleto.folio_tarjeta = respuesta.autorizacion;
            this.payCanjeTicket();
          }else{
            this.confirmarReserva.folio_tarjeta = respuesta.autorizacion;
            this.payConfirmaReserva();
          }
        }else{
          this.mensaje_error_pago_tarjeta = respuesta.mensaje+': '+respuesta.detalle;
          this.loadingSpinner = false;
          this.equipajeExtra.tarjeta = null;
          this.canjearBoleto.tarjeta = null;
          this.confirmarReserva.tarjeta = null;
        }
      });
    },
    cerrarCanje(){
      if(this.payment_details.length > 0){
        this.deleteDetail(0);
      }
      this.showVentaCanjeBoletoModal = false;
    },
    RemoveSocket(){
      const listener = (e) => {};
      const channel = Echo.channel(`Subcorrida.${this.canjearBoleto.subcorrida_id}`).listen('AsientoInteractivoEvent', listener);
      channel.subscription.unbind(channel.eventFormatter.format('AsientoInteractivoEvent'), listener);
    },
    salirVer(){
      this.boleto_info = null;
      this.showVerBoletoModal = false; 
    },
    changeSimbol(s) {
      //var accent_map = {'á':'&aacute;', 'é':'&eacute;', 'è':'e', 'í':'&iacute;','ó':'&oacute;','ú':'&uacute;','Á':'&Aacute;', 'É':'&Eacute;', 'è':'e', 'Í':'&Iacute;','Ó':'&Oacute;','Ú':'&Uacute;', 'ñ':'&ntilde;;', 'Ñ':'&Ntilde;'};
      var accent_map = {'á':'a', 'é':'e', 'è':'e', 'í':'i','ó':'o','ú':'u','Á':'a', 'É':'e', 'è':'e', 'Í':'i','Ó':'o','Ú':'u', 'Ñ':'N', 'ñ':'n'};
      if (!s) { return ''; }
      var ret = '';
      for (var i = 0; i < s.length; i++) {
        ret += accent_map[s.charAt(i)] || s.charAt(i);
      }
      return ret;
    },
    async addImageToPrint(linea){
      //transforma imagen a base64
      const getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob); 
          reader.onloadend = () => {
            const base64data = reader.result;   
            resolve(base64data);
          }
        });
      }
      let imagen;
      //elige imagen a imprimir según linea de ruta
      switch(linea){
        case 1:
          imagen = await getBase64FromUrl('/img/logoPrinter.png');
          return imagen;
        case 2:
          imagen = await getBase64FromUrl('/img/logoPrinter3.png');
          return imagen;
      }
    },
    async imprimir(boletos, tipo){ 
      //se obtienen datos de usuario autenticado
      let me = await this.$store.getters["profile/me"];
      //se obtienen datos de linea a la que corresponde el boleto
      let linea = null;
      if(tipo === 'anula'){
        linea = this.boleto_info.ruta.linea;
      }else if(tipo === 'reimprime'){
        linea = boletos.result.ruta.linea;
      }else if(tipo === 'confirma_reserva'){
        linea = boletos[0].ruta.linea;
      }else{
        linea = boletos.ruta.linea;
      }
      
      let imagen = await this.addImageToPrint(linea); 
      let printer = new Impresora;
      //tipos de impresiones
      if(tipo === 'anula'){
        let tablaClass = Vue.extend(ImpresionAnular);
        let tablaInstancia = new tablaClass({
          propsData: { 
              boleto: boletos,
              user: me.attributes,
              monto: this.calculatePagosRecibidos
          }
        });
        let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
        let tabla = this.changeSimbol(tabla_html);
        printer.setAlign("center");
        printer.imagen(imagen);
        printer.setAlign("left");
        printer.html(tabla);
        printer.cut();
      }
      if(tipo === 'confirma_reserva'){
        for(let i=0; i < boletos.length; i++){
          let tablaClass = Vue.extend(ReImpresionBoletos);
          let tablaClass2 = Vue.extend(ReImpresionBoletos2);
          let tablaInstancia = new tablaClass({
            propsData: { 
                boleto: boletos[i],
                user: me.attributes,
                linea: linea
            }
          });
          let tablaInstancia2 = new tablaClass2({
            propsData: { 
                boleto: boletos[i],
                user: me.attributes,
            }
          });
          let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
          let tabla_html2 = (tablaInstancia2.$mount().$el.outerHTML).toString();
          let tabla = this.changeSimbol(tabla_html);
          let tabla2 = this.changeSimbol(tabla_html2);
          printer.setAlign("center");
          printer.imagen(imagen);
          printer.setAlign("left");
          printer.html(tabla);
          printer.setAlign("center");
          printer.qr(boletos[i].id, 25)
          printer.cut();
          printer.setAlign("left");
          printer.html(tabla2);
          printer.cut();
        }
      }
      if(tipo === 'canje'){
        if(boletos.asiento === null){
          let tablaClass = Vue.extend(ImpresionBoletosBlanco);
              let tablaInstancia = new tablaClass({
                propsData: { 
                    boleto: boletos,
                    user: me.attributes,
                    linea: linea
                }
              });
              let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
              let tabla = this.changeSimbol(tabla_html);
              printer.setAlign("center");
              printer.imagen(imagen);
              printer.setAlign("left");
              printer.html(tabla);
              printer.cut();
        }else{
          let tablaClass = Vue.extend(ImpresionCanje);
          let tablaClass2 = Vue.extend(ImpresionCanje2);
          let tablaInstancia = new tablaClass({
            propsData: { 
                boleto: boletos,
                linea: linea
            }
          });
          let tablaInstancia2 = new tablaClass2({
            propsData: { 
              user: me.attributes,
              boleto: boletos,
            }
          });
          let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
          let tabla_html2 = (tablaInstancia2.$mount().$el.outerHTML).toString();
          let tabla = this.changeSimbol(tabla_html);
          let tabla2 = this.changeSimbol(tabla_html2);
          printer.setAlign("center");
          printer.imagen(imagen);
          printer.setAlign("left");
          printer.html(tabla);
          printer.setAlign("center");
          printer.qr(this.boleto_info.id, 25);
          printer.cut();
          printer.setAlign("left");
          printer.html(tabla2);
          printer.cut();
          if(this.diferencia_liquidar === true || this.diferencia_devolver === true){
            let tablaClassComprobante = Vue.extend(ComprobanteCanje);
            let tablaInstanciaComprobante = new tablaClassComprobante({
              propsData: { 
                  boleto: this.boleto_info,
                  user: me.attributes,
                  importe: Number(this.calculateTotal).toFixed(2)
              }
            });
            let tabla_html = (tablaInstanciaComprobante.$mount().$el.outerHTML).toString();
            let tablaComprobante = this.changeSimbol(tabla_html);
            printer.setAlign("center");
            printer.imagen(imagen);
            printer.setAlign("left");
            printer.html(tablaComprobante);
            printer.cut();
          }
        }
        
      }
      if(tipo === 'equipaje'){
        let tablaClass = Vue.extend(ImpresionEquipajeExtra);
        let tablaInstancia = new tablaClass({
          propsData: { 
              boleto: boletos,
              user: me.attributes,
              cantidad: this.equipajeExtra.cantidad_piezas,
              monto: this.equipajeExtra.monto
          }
        });
        let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
        let tabla = this.changeSimbol(tabla_html);
        printer.setAlign("center");
        printer.imagen(imagen);
        printer.setAlign("left");
        printer.html(tabla);
        printer.cut();
        this.equipajeExtra = {
          type: "pago equipaje extra",
          boleto_id: null,
          efectivo: true,
          efectivo_mxn: null,
          efectivo_usd: null,
          cantidad_piezas: null,
          tarjeta: null,
          pago_tarjeta: false,
          folio_tarjeta: null,
          deposito: null,
          pago_deposito: false,
          folio_deposito: null,
          total_metodos: null,
          cambio: null,
          saldo_efectivo_mxn: null,
          monto: null
        };
      }
      if(tipo === 'reimprime'){
        let tablaClass = Vue.extend(ReImpresionBoletos);
        let tablaClass2 = Vue.extend(ReImpresionBoletos2);
        let tablaInstancia = new tablaClass({
          propsData: { 
              boleto: boletos.result,
              user: me.attributes,
              linea: linea
          }
        });
        let tablaInstancia2 = new tablaClass2({
          propsData: { 
              boleto: boletos.result,
              user: me.attributes,
          }
        });
        let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
        let tabla_html2 = (tablaInstancia2.$mount().$el.outerHTML).toString();
        let tabla = this.changeSimbol(tabla_html);
        let tabla2 = this.changeSimbol(tabla_html2);
        printer.setAlign("center");
        printer.imagen(imagen);
        printer.setAlign("left");
        printer.html(tabla);
        printer.setAlign("center");
        printer.qr(this.boleto_info.id, 25);
        printer.cut();
        printer.setAlign("left");
        printer.html(tabla2);
        printer.cut();
      }
      printer.end().then(respuesta => {
          if(tipo === 'canje' || tipo === 'confirma_reserva'){
            this.reload();
          }else{
            this.getBoleto(this.boleto_info.id);
          }
      });
    },  
    async imprimirLista(){
      //se obtienen datos de usuario autenticado
      let me = await this.$store.getters["profile/me"];
      let imagen = await this.addImageToPrint(this.listaAbordaje[0].attributes.linea);

      let printer = new Impresora;
      let tablaClass = Vue.extend(ImpresionListaAbordaje);
      let tablaInstancia = new tablaClass({
        propsData: { 
            lista: this.listaAbordaje,
            user: me.attributes,
            corrida: this.canjearBoleto
        }
      });
      let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
      let tabla = this.changeSimbol(tabla_html);
      printer.setAlign("center");
      printer.imagen(imagen);
      //printer.setAlign("center");
      printer.html(tabla);
      printer.cut();
      printer.end().then(respuesta => {
          if(respuesta.status === true){
            this.reload();
          }
      });
      this.reload();
    },
    reload(){
      this.$router.go(this.$router.currentRoute)
    },
    validateAge(){
      let total = 0;
      for(let i = 0; i < this.payment_details.length; i++){
        if(this.payment_details[i].edad !== undefined){
          if(this.payment_details[i].edad < 18){
            total++;
          }
        }
      }
      if(this.payment_details.length === total && this.payment_details.length !== 0){
        this.validacionEdad = true;
      }else{
        this.validacionEdad = false;
      }
    },
    async payCanjeTicket(){
      //monto lo que se va a pagar
      //diferencia lo q se devuelve
      this.canjearBoleto.token_id = this.token_id;
      this.canjearBoleto.boletos = [];
      this.canjearBoleto.boletos[0] = this.boleto_info;
      this.canjearBoleto.asientos = [];
      this.canjearBoleto.asientos[0] = this.payment_details[0];
      this.canjearBoleto.tasa_usd_mxn = this.tasa_usd_mxn;
      //permisos
      if(this.token_canje_despues_salida != null){
        this.canjearBoleto.token_canje_despues_salida = this.token_canje_despues_salida;
      }
      if(this.token_canje_con_devolucion != null){
        this.canjearBoleto.token_canje_con_devolucion = this.token_canje_con_devolucion;
      }
      if(this.token_canje_sin_pago != null){
        this.canjearBoleto.token_canje_sin_pago = this.token_canje_sin_pago;
      }
      if(this.token_descuento != null){
        this.canjearBoleto.token_descuento = this.token_descuento;
      }
      //tipos de pagos
      this.canjearBoleto.es_pago_contado = true;
      if(this.canjearBoleto.se_devuelve === true){
        this.canjearBoleto.diferencia = this.calculateTotal * -1;
        this.canjearBoleto.se_devuelve_diferencia = true;
        this.canjearBoleto.se_cobra = false;
        this.canjearBoleto.se_cobra_diferencia = false;
        this.canjearBoleto.monto = null;
      }
      if(this.canjearBoleto.se_cobra === true){
        this.canjearBoleto.monto = this.calculateTotal;
        this.canjearBoleto.se_cobra_diferencia = true;
        this.canjearBoleto.se_devuelve_diferencia = false;
      }
      if(this.canjearBoleto.se_devuelve === false && this.canjearBoleto.se_cobra === false){
        this.canjearBoleto.se_cobra_diferencia = false;
        this.canjearBoleto.se_devuelve_diferencia = false;
        this.canjearBoleto.monto = null;
      }
      if(this.canjearBoleto.motivo_se_devuelve){
        this.canjearBoleto.motivo = this.canjearBoleto.motivo_se_devuelve;
      }
      if(this.canjearBoleto.motivo_no_se_cobra){
        this.canjearBoleto.motivo = this.canjearBoleto.motivo_no_se_cobra;
      }
      /*
      if(this.canjearBoleto.pago_tarjeta === true){
        this.showPagoConfirmaReservaTarjeta = true;
      }else{
      */
      this.canjearBoleto.boleto_id = this.boleto_info.id;
      this.canjearBoleto.efectivo_usd_mxn = (this.canjearBoleto.tasa_usd_mxn * this.canjearBoleto.efectivo_usd);
      if(this.canjearBoleto.efectivo_usd_mxn === 0){
        this.canjearBoleto.efectivo_usd_mxn = null;
      }
      if(this.canjearBoleto.tarjeta === 0){
        this.canjearBoleto.tarjeta = null;
      }
      if(this.canjearBoleto.deposito === 0){
        this.canjearBoleto.deposito = null;
      }
      this.canjearBoleto.monto_real = this.calculateTotal;
      this.canjearBoleto.total_metodos = this.calculateAcumulado;
      this.canjearBoleto.cambio = this.calculateCambio;
      this.canjearBoleto.saldo_efectivo_mxn = this.canjearBoleto.efectivo_mxn - this.calculateCambio;

      this.canjearBoleto.corrida_ida_id = this.canjearBoleto.corrida_id;
      this.canjearBoleto.subcorrida_ida_id = this.canjearBoleto.subcorrida_id;
      this.canjearBoleto.ruta_ida_id = this.canjearBoleto.ruta_id;
      
      var fecha_salida_ida = this.canjearBoleto.fecha_salida_real;
      fecha_salida_ida = fecha_salida_ida.substr(0, fecha_salida_ida.length - 1);
      fecha_salida_ida = fecha_salida_ida.substr(0, fecha_salida_ida.length - 1);
      fecha_salida_ida = fecha_salida_ida.substr(0, fecha_salida_ida.length - 1);
      this.canjearBoleto.fecha_salida_ida = fecha_salida_ida;
      
      //this.canjearBoleto.fecha_salida_ida = this.canjearBoleto.fecha_salida;
      if(this.canjearBoleto.subida === undefined){
        this.canjearBoleto.paradero_origen_ida = this.canjearBoleto.paraderos_ida[0];
      }else{
        this.canjearBoleto.paradero_origen_ida = this.canjearBoleto.subida;
      }
      if(this.canjearBoleto.bajada === undefined){
        this.canjearBoleto.paradero_destino_ida = this.canjearBoleto.paraderos_ida[0];
      }else{
        this.canjearBoleto.paradero_destino_ida = this.canjearBoleto.bajada;
      }

      try {
        await this.$store.dispatch("boletos/canjeBoleto", this.canjearBoleto).then(() => {
          this.boletos_canje = this.$store.getters["boletos/canjeBoleto"];
          this.boletos_canje = this.boletos_canje.result.boletos;
        });
        this.$notify({
          type: "success",
          message: "Se realizo canje de boleto satisfactoriamente.",
          duration: -1
        });
        //this.showBoletoCanjeadoModal = true;
        this.showVentaCanjeBoletoModal = false;
        this.RemoveSocket();
        this.imprimir(this.boletos_canje, 'canje');
        this.getBoleto(this.boleto_info.id);
        this.getList();
        this.resetApiValidation();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        this.resetApiValidation();
        this.setApiValidation(error.response.data.errors);
      }
    },
    changeSeDevuelve(){
      if(this.canjearBoleto.se_devuelve){
        this.canjearBoleto.no_se_devuelve = false;
      }else{
        this.canjearBoleto.no_se_devuelve = true;
      }
    },
    changeNoSeDevuelve(){
      if(this.canjearBoleto.no_se_devuelve){
        this.canjearBoleto.se_devuelve = false;
      }else{
        this.canjearBoleto.se_devuelve = true;
      }
    },
    canjeDevolver(){
      if(this.canjearBoleto.se_devuelve === true){
        if(this.canjearBoleto.motivo_se_devuelve === null){
          this.$notify({
            type: "danger",
            message: "Es necesario ingresar un motivo!",
            duration: -1
          });
        }else{
          this.validatePermisoCanjeConDevolucion();
        }
      }else{
        this.showCanjeDevolverModal = false;
        //this.showPayCanjeTicketModal = true;
        this.payCanjeTicket();
      }
    },
    changeSeCobra(){
      if(this.canjearBoleto.se_cobra){
        this.canjearBoleto.no_se_cobra = false;
      }else{
        this.canjearBoleto.no_se_cobra = true;
      }
    },
    changeNoSeCobra(){
      if(this.canjearBoleto.no_se_cobra){
        this.canjearBoleto.se_cobra = false;
      }else{
        this.canjearBoleto.se_cobra = true;
      }
    },
    canjeLiquidar(){
      if(this.canjearBoleto.no_se_cobra === true){
        if(this.canjearBoleto.motivo_no_se_cobra === null){
          this.$notify({
            type: "danger",
            message: "Es necesario ingresar un motivo!",
            duration: -1
          });
        }else{
          this.validatePermisoCanjeSinPago();
        }
      }else{
        this.showCanjeLiquidarModal = false;
        this.showPayCanjeTicketModal = true;
        //this.payCanjeTicket();
      }
    },
    //validacion de boletos antes de pago
    validateTickets(){
      let pasa = true;
      let descuento = 0;
      
      for(let i = 0; i < this.payment_details.length; i++){
        if(this.payment_details[i].asiento === ' '){
          pasa = false;
          this.$notify({
            type: "danger",
            message: "Existen boletos sin asiento asignado",
            duration: -1
          });
          break;
        }
        if(this.payment_details[i].nombre_pasajero === undefined){
          pasa = false;
          this.$notify({
            type: "danger",
            message: "Existen boletos sin nombre",
            duration: -1
          });
          break;
        }
        if(this.payment_details[i].edad === undefined){
          pasa = false;
          this.$notify({
            type: "danger",
            message: "Existen boletos sin edad",
            duration: -1
          });
          break;
        }
        if(this.payment_details[i].descuento != undefined){
          if(this.payment_details[i].descuento.tipo_descuento === 'Especial'){
            descuento++;
          }
        }
      } 
      if(pasa){
        if(descuento > 0){
          this.validatePermisoPago();
        }else{
          this.payTickets();
        }
      }
    },
    async authCanjeConDevolucion(){
      this.auth.permiso = 'view autorizar canje con devolucion';
      try {
        await this.$store.dispatch("ventas/autorizacionToken", this.auth).then(() => {
          this.token_canje_con_devolucion = this.$store.getters["ventas/autorizacionToken"];
          this.token_canje_con_devolucion = this.token_canje_con_devolucion.result.token;
        });
        this.$notify({
          type: "success",
          message: "Canje con devolucion autorizado satisfactoriamente.",
          duration: -1
        });
        this.auth.token = null;
        this.showAutorizaCanjeConDevolucionModal = false;
        this.showCanjeDevolverModal = false;
        this.payCanjeTicket();
        //this.showPayCanjeTicketModal = true;
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
    },
    //valida permiso de canje sin pago
    async validatePermisoCanjeConDevolucion(){
      this.permiso.permiso = 'view autorizar canje con devolucion';
      try {
        await this.$store.dispatch("ventas/verificacion", this.permiso);
        //let me = await this.$store.getters["profile/me"];
        //this.token_canje_con_devolucion = me.id;
        this.showCanjeDevolverModal = false;
        this.payCanjeTicket();
        //this.showPayCanjeTicketModal = true;
      }catch (error) {
        this.showAutorizaCanjeConDevolucionModal = true;
      }
    },

    async authCanjeSinPago(){
      //this.auth.permiso = 'view autorizar canje sin pago';
      try {
        await this.$store.dispatch("ventas/autorizacionToken", this.auth).then(() => {
          this.token_canje_sin_pago = this.$store.getters["ventas/autorizacionToken"];
          this.token_canje_sin_pago = this.token_canje_sin_pago.result.token;
        });
        this.$notify({
          type: "success",
          message: "Token de autorización validado satisfactoriamente.",
          duration: -1
        });
        this.auth.token = null;
        this.showAutorizaCanjeSinPagoModal = false;
        //this.showCanjeLiquidarModal = false;
        this.payCanjeTicket();
        //this.showPayCanjeTicketModal = true;
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
    },
    //valida permiso de canje sin pago
    async validatePermisoCanjeSinPago(){
      this.permiso.permiso = 'view autorizar canje sin pago';
      try {
        await this.$store.dispatch("ventas/verificacion", this.permiso);
        //let me = await this.$store.getters["profile/me"];
        //this.token_canje_sin_pago = me.id;
        this.showCanjeLiquidarModal = false;
        this.payCanjeTicket();
        //this.showPayCanjeTicketModal = true;
      }catch (error) {
        this.showCanjeLiquidarModal = false;
        this.showAutorizaCanjeSinPagoModal = true;
      }
    },
    //valida tipo de pago devolver, cobrar
    payTickets(){
      if(Number(this.calculateTotal) === 0){
        //console.log('valen lo mismo')
        this.canjearBoleto.motivo = null;
        this.canjearBoleto.se_devuelve = false;
        this.canjearBoleto.se_cobra = false;
        this.payCanjeTicket();
      }
      //con diferencia a devolver
      if(Number(this.calculateTotal) < 0){
        //console.log('precio boleto anterior'+':'+this.boleto_info.precio_lista)
        //console.log('precio boleto nuevo'+':'+this.calculateTotal)
        this.canjearBoleto.se_devuelve = true;
        this.canjearBoleto.se_cobra = false;
        this.diferencia_devolver = true;
        this.showCanjeDevolverModal = true;
      }
      //con diferencia a liquidar
      if(Number(this.calculateTotal) > 0){
        //console.log('precio boleto anterior'+':'+this.boleto_info.precio_lista)
        //console.log('precio boleto nuevo'+':'+this.calculateTotal)
        this.canjearBoleto.se_cobra = true;
        this.canjearBoleto.se_devuelve = false;
        this.diferencia_liquidar = true;
        this.showCanjeLiquidarModal = true;
      }
    },
    //si existe al menos un descuento especial valida si usuario logueado tiene permiso
    async validatePermisoPago(){
      this.permiso.permiso = 'view autorizar descuento';
      try {
        await this.$store.dispatch("ventas/verificacion", this.permiso);
        //let me = await this.$store.getters["profile/me"];
        //this.token_descuento = me.id;
        this.payTickets();
      }catch (error) {
        this.showAutorizaPagoDescuentoModal = true;
      }
    },
    //si el usuario logueado no tiene permiso valida credenciales de usuario con permiso de descuento
    async authPagoDescuento(){
      this.auth.permiso = 'view autorizar descuento';
      try {
        await this.$store.dispatch("ventas/autorizacionToken", this.auth).then(() => {
          this.token_descuento = this.$store.getters["ventas/autorizacionToken"];
          this.token_descuento = this.token_descuento.result.token;
        });
        this.$notify({
          type: "success",
          message: "Pago con descuento autorizado satisfactoriamente.",
          duration: -1
        });
        this.auth.token = null;
        this.showAutorizaPagoDescuentoModal = false;
        this.payTickets();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
    },
    /*
    //valida si existen asientos disponible de categoria primera
    validationBlancosDisponibles(categoria){
      let total = 0;
      for(let i = 0; i < this.canjearBoleto.estructura[0].length; i++){
        for(let j = 0; j < this.canjearBoleto.estructura[0][i].length; j++){
          if(this.canjearBoleto.estructura[0][i][j] != null && this.canjearBoleto.estructura[0][i][j].tipo == 'asiento'){
            if(this.canjearBoleto.estructura[0][i][j].categoria.nombre === categoria && this.canjearBoleto.estructura[0][i][j].disponible === 1){
                total++;
              }
              if(this.canjearBoleto.estructura[0][i][j].categoria.nombre === categoria && this.canjearBoleto.estructura[0][i][j].disponible === 1){
                total++;
              }
          }
        }
        if(this.canjearBoleto.estructura[1] != null){
          for(let j = 0; j < this.canjearBoleto.estructura[1].length; j++){
            if(this.canjearBoleto.estructura[1][i][j] != null && this.canjearBoleto.estructura[1][i][j].tipo == 'asiento'){
              if(this.canjearBoleto.estructura[1][i][j].categoria.nombre === categoria && this.canjearBoleto.estructura[1][i][j].disponible === 1){
                total++;
              }
              if(this.canjearBoleto.estructura[1][i][j].categoria.nombre === categoria && this.canjearBoleto.estructura[1][i][j].disponible === 1){
                total++;
              }
            }
          }
        }
      }
      return total;
    },
    validationTotalBlancos(categoria_id){
      let total = 1;
      for(let i = 0; i < this.payment_details.length; i++){
        if(this.payment_details[i].categoria.id === categoria_id){
          total++;
        }
      }
      return total;
    },*/
    //agrega dato en array de canje
    addBlancoPrimera(){
      if(this.payment_details.length === 1){
        this.$notify({
          type: "danger",
          message: "Solo es posible canjear un boleto",
          duration: -1
        });
        return;
      }
      let precio = this.canjearBoleto.precios.filter(item => item.nombre == "Básica");
      this.payment_details.push({
        nombre_pasajero:  this.boleto_info.nombre_pasajero,
        edad:  this.boleto_info.edad,
        tipo_viaje: this.activeTab, 
        asiento: 'B B',
        categoria: {id: 1},
        precio_taquilla: precio[0].precio_taquilla,
        es_blanco: 1,
        descuento: undefined,
        numero: null,
        monto_canje: 0,
      });
    },
    //agrega dato en array de canje
    addBlancoEjecutiva(){
      if(this.payment_details.length === 1){
        this.$notify({
          type: "danger",
          message: "Solo es posible canjear un boleto",
          duration: -1
        });
        return;
      }
      let precio = this.canjearBoleto.precios.filter(item => item.nombre == "Ejecutiva");
      this.payment_details.push({
        nombre_pasajero:  this.boleto_info.nombre_pasajero,
        edad:  this.boleto_info.edad,
        tipo_viaje: this.activeTab, 
        asiento: 'B E',
        categoria: {id: 2},
        precio_taquilla: precio[0].precio_taquilla,
        es_blanco: 1,
        descuento: undefined,
        numero: null,
        monto_canje: 0,
      });
    },
    //agrega dato en array de canje
    addBlancoConfort(){
      if(this.payment_details.length === 1){
        this.$notify({
          type: "danger",
          message: "Solo es posible canjear un boleto",
          duration: -1
        });
        return;
      }
      let precio = this.canjearBoleto.precios.filter(item => item.nombre == "Confort");
      this.payment_details.push({
        nombre_pasajero:  this.boleto_info.nombre_pasajero,
        edad:  this.boleto_info.edad,
        tipo_viaje: this.activeTab, 
        asiento: 'B C',
        categoria: {id: 3},
        precio_taquilla: precio[0].precio_taquilla,
        es_blanco: 1,
        descuento: undefined,
        numero: null,
        monto_canje: 0,
      });
    },
    //agrega dato en array de canje
    addDetail(asiento){
      if(this.payment_details.length === 1){
        this.$notify({
          type: "danger",
          message: "Solo es posible canjear un boleto",
          duration: -1
        });
        return;
      }
      let categoriaNombre;
      if(asiento.categoria.nombre != undefined){
        categoriaNombre = asiento.categoria.nombre.charAt(0);
      }else{
        categoriaNombre = asiento.categoria;
      }
      if(this.cambiando_asiento){
        this.payment_details[this.asiento_index].nombre_pasajero = this.boleto_info.nombre_pasajero;
        this.payment_details[this.asiento_index].edad = this.boleto_info.edad;
        this.payment_details[this.asiento_index].asiento = asiento.numero+' '+categoriaNombre;
        this.payment_details[this.asiento_index].numero = asiento.numero;
        this.payment_details[this.asiento_index].categoria = asiento.categoria;
        this.payment_details[this.asiento_index].es_blanco = 0;
        this.payment_details[this.asiento_index].precio_taquilla = asiento.precio_taquilla;
        this.payment_details[this.asiento_index].pagado_canje = this.canjearBoleto.monto_total_pagar;
        this.payment_details[this.asiento_index].id = asiento.id;
        this.payment_details[this.asiento_index].descuento = undefined;
        this.payment_details[this.asiento_index].classActive = false;
        this.payment_details[this.asiento_index].nivel = this.nivelActual;
        this.cambiando_asiento = false;
        this.asiento_index = null;
      }else{
        this.payment_details.push({
          nombre_pasajero:  this.boleto_info.nombre_pasajero,
          edad:  this.boleto_info.edad,
          tipo_viaje: this.activeTab, 
          classActive: false,
          asiento: asiento.numero+' '+categoriaNombre,
          numero: asiento.numero,
          es_blanco: 0,
          categoria: asiento.categoria,
          precio_taquilla: asiento.precio_taquilla,
          pagado_canje: this.canjearBoleto.monto_total_pagar,
          id: asiento.id,
          descuento: undefined,
          nivel: this.nivelActual 
        });
      }
    },
    //cambia dato en array de canje
    changeDetail(index){
      this.cambiando_asiento = true;
      this.asiento_index = index;
      this.payment_details[index].asiento = ' ';
      this.payment_details[index].classActive = true;
      this.payment_details[index].es_blanco = 0;
      if(this.payment_details[index].id != undefined){
        const id = this.payment_details[index].id;
        const item = this.$refs[id];
        if(this.payment_details[index].nivel === '1'){
          item[0].resetAsiento();
        }else{
          if(item.length === 2){
            item[1].resetAsiento();
          }else{
            item[0].resetAsiento();
          }
        }
      }
      //this.payment_details.splice(index,1,'asiento');
    },
    //borra dato en array de canje
    deleteDetail(index){
      if(this.payment_details[index].id != undefined){
        const id = this.payment_details[index].id;
        const item = this.$refs[id];
        if(this.payment_details[index].nivel === '1'){
          item[0].resetAsiento();
        }else{
          if(item.length === 2){
            item[1].resetAsiento();
          }else{
            item[0].resetAsiento();
          }
        }
        this.payment_details.splice(index,1);
      }else{
        this.payment_details.splice(index,1);
      }
    },

    countDiscounts(limite_descuentos, id){
      let total = 0;
      for(let i=0; i < this.payment_details.length; i++){
        if(this.payment_details[i].descuento != undefined){
          if(this.payment_details[i].descuento.id === id){
            total++;
          }
        } 
      }
      if(total <= limite_descuentos){
        return true;
      }else{
        return false;
      }
    },
    //valida si existe mensaje en descuento seleccionado
    async checkDescuento(descuento, index){
      var data = [];
      data.corrida_id = this.canjearBoleto.corrida_id;
      data.descuento_id = descuento.id;
      await this.$store.dispatch("descuentos/getTotalPorCorrida", data).then(() => {
        this.descuento_validacion = this.$store.getters["descuentos/getTotalPorCorrida"];
      });
      let validacion = this.countDiscounts((Number(descuento.cantidad_maxima) - Number(this.descuento_validacion.result)), descuento.id);

      if(this.descuento_validacion.success && validacion){
        this.$notify({
          type: "success",
          message: "Descuento asignado satisfactoriamente.",
          duration: -1
        });
        //if para validar si ya tiene token de autorización de descuento
        this.checkAuthDiscount();
      }else{
        this.$notify({
          type: "danger",
          message: `No existen más descuentos ${descuento.nombre} disponibles.`,
          duration: -1
        });
        this.payment_details[index].descuento = null;
        return;
      }

      if(descuento.mensaje_taquilla != null){
        this.mensaje_taquilla = descuento.mensaje_taquilla;
        this.showDescuentoMensajeTaquilla = true;
      }
    },
    async getDescuentos(id){
      await this.$store.dispatch("descuentos/listActive",id).then(() => {
        this.descuentos = this.$store.getters["descuentos/listActive"];
      });
    },
    //calcula el resultado matematico final en lista de boletos 
    calculateFinal(index){
    var result=0.0;
      if(this.payment_details[index] !== undefined){
        if(this.payment_details[index].monto_canje === undefined){
          this.payment_details[index].monto_canje = 0;
        }
        if(this.payment_details[index].descuento === undefined || this.payment_details[index].descuento === null){
          result = parseInt(this.payment_details[index].precio_taquilla);
          this.payment_details[index].descuento = { tipo_valor: '$', valor: 0};
        }else{
          if(this.payment_details[index].descuento.tipo_valor === '%'){
            result = parseInt(this.payment_details[index].precio_taquilla) - (parseInt(this.payment_details[index].precio_taquilla) * (parseInt(this.payment_details[index].descuento.valor)/100));
            this.payment_details[index].monto_descuento = (parseInt(this.payment_details[index].precio_taquilla) * (parseInt(this.payment_details[index].descuento.valor)/100)); 
          }else{
            result = parseInt(this.payment_details[index].precio_taquilla) - parseInt(this.payment_details[index].descuento.valor);
            this.payment_details[index].monto_descuento = parseInt(this.payment_details[index].descuento.valor); 
          }
        }
      }
      return result - this.calculatePagosRecibidos;
    },
    //valida status para canje de boleto 
    async canjeBoleto(){
      this.createToken();
      this.getTerminales();
      if(this.boleto_info.fecha_salida != null){
        var hoy = new Date();
        var dateControlFecha = this.boleto_info.fecha_salida.split('-');
        var dateControlFecha2 = dateControlFecha[2].split(' ');
        var dateControlHora = dateControlFecha2[1].split(':');
        var dateControl = new Date(dateControlFecha[0], dateControlFecha[1]-1, dateControlFecha2[0], dateControlHora[0], dateControlHora[1], dateControlHora[2]);
        if(dateControl < hoy){
          this.validatePermisoCanjeDespuesSalida();
          //this.showAutorizarCanjeBoletoModal = true;
        }else{
          this.showVentaCanjeBoletoModal = true;
          this.showSeleccionSubcorridaModal = true;
        }
      }else{
        this.showVentaCanjeBoletoModal = true;
        this.showSeleccionSubcorridaModal = true;
        //this.showAutorizarCanjeBoletoModal = true;
      }
    },
    async validatePermisoCanjeDespuesSalida(){
      this.permiso.permiso = 'view autorizar canje despues salida';
      try {
        await this.$store.dispatch("boletos/verificacion", this.permiso);
        this.showVentaCanjeBoletoModal = true;
        this.showSeleccionSubcorridaModal = true;
      }catch (error) {
        this.showAutorizarCanjeBoletoModal = true;
      }
    },
    async authCanjearBoleto(){
      //this.auth.permiso = 'view autorizar canje despues salida';
      try {
        await this.$store.dispatch("boletos/autorizacionToken", this.auth).then(() => {
          this.token_canje_despues_salida = this.$store.getters["boletos/autorizacionToken"];
          this.token_canje_despues_salida = this.token_canje_despues_salida.result.token;
        });
        this.$notify({
          type: "success",
          message: "Canje despues de salida autorizado satisfactoriamente.",
          duration: -1
        });
        this.resetApiValidation();
        this.closeModal();
        this.auth.token = null;
        this.showVentaCanjeBoletoModal = true;
        this.showSeleccionSubcorridaModal = true;
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
    },
    //crea token de venta
    async createToken(){
      const data = {
        attributes: {}
      };
      data.attributes.canal = 1;
      await this.$store.dispatch("boletos/crearToken", data).then(() => {
        this.token_id = this.$store.getters["boletos/crearToken"];
        this.token_id = this.token_id.result.token_id;
      });
    },
    //resetea variables de canje boleto
    resetCanjearBoleto(){
      this.canjearBoleto = {
        type: "canjear boleto",
        boleto_id: null,
        efectivo: true,
        efectivo_mxn: null,
        efectivo_usd: null,
        tarjeta: null,
        pago_tarjeta: false,
        folio_tarjeta: null,
        deposito: null,
        pago_deposito: false,
        folio_deposito: null,
        total_metodos: null,
        cambio: null,
        saldo_efectivo_mxn: null,
        monto: null,
        se_cobra: true,
        no_se_cobra: false,
        motivo_no_se_cobra: null,
        se_devuelve: false,
        no_se_devuelve: true,
        motivo_se_devuelve: null,
        token_descuento: null,
        token_canje_despues_salida: null,
        token_canje_sin_pago: null,
        token_canje_con_devolucion: null,
        es_pago_contado: null,
        email: null,
        telefono: null,
        agencia_id: null,
        diferencia: null,
        monto: null,
        boletos: [],
        motivo: null
      };
      this.payment_details = [];
    },
    //despues de seleccionar subcorrida en componente de subcorridas llena datos de canje
    async handleCurrentChange(val) {
      if(val === null) return;
      await this.$store.dispatch("subcorridas/getDatosVenta", val.id).then(() => {
          this.resetCanjearBoleto();
          const canje = this.canjearBoleto;
          const canje_carga = this.$store.getters["subcorridas/getDatosVenta"];
          this.canjearBoleto = Object.assign(canje, canje_carga);
          const paraderos_ida = JSON.parse(this.canjearBoleto.tramo.terminal_origen.paraderos);
          this.canjearBoleto.paraderos_ida = paraderos_ida;
          const paraderos_vuelta = JSON.parse(this.canjearBoleto.tramo.terminal_destino.paraderos);
          this.canjearBoleto.paraderos_vuelta = paraderos_vuelta;
          //this.canjearBoleto.subida = paraderos_ida[0];
          //this.canjearBoleto.bajada = paraderos_vuelta[0];
          this.canjearBoleto.agencia_id = this.anularBoleto.agencia_id;
          this.getDescuentos(this.canjearBoleto.subcorrida_id);
      });
      if(this.canjearBoleto.precios_taquilla_faltantes.length > 0){
        if(this.canjearBoleto.precios_taquilla_faltantes.length === 1){
          this.$notify({
            type: "danger",
            message: `¡No existen precios vigentes de ${this.canjearBoleto.precios_taquilla_faltantes[0]} para subcorrida seleccionada!`,
            duration: -1
          });
        }
        if(this.canjearBoleto.precios_taquilla_faltantes.length === 2){
          this.$notify({
            type: "danger",
            message: `¡No existen precios vigentes de ${this.canjearBoleto.precios_taquilla_faltantes[0]} y ${this.canjearBoleto.precios_taquilla_faltantes[1]} para subcorrida seleccionada!`,
            duration: -1
          });
        }
        if(this.canjearBoleto.precios_taquilla_faltantes.length === 3){
          this.$notify({
            type: "danger",
            message: `¡No existen precios vigentes de ${this.canjearBoleto.precios_taquilla_faltantes[0]}, ${this.canjearBoleto.precios_taquilla_faltantes[1]} y ${this.canjearBoleto.precios_taquilla_faltantes[2]} para subcorrida seleccionada!`,
            duration: -1
          });
        }
        this.resetCanjearBoleto();
      }else{
        this.showSeleccionSubcorridaModal = false;
      }
    },
    //control slider de canje nivel uno
    nivelUno(){   
      this.mostrarNivelUno = true;
      this.mostrarNivelDos = false;
      this.nivelActual = '1';
    },
    //control slider de canje nivel dos
    nivelDos(){
      this.mostrarNivelUno = false;
      this.mostrarNivelDos = true;
      this.nivelActual = '2';
    },

    async listaAbordajeModal($id){
      await this.$store.dispatch("corridas/listAbordaje", $id).then(() => {
        this.listaAbordaje = this.$store.getters["corridas/listAbordaje"];
      });
      await this.$store.dispatch("corridas/getTotalVentaCorrida", $id).then(() => {
          this.TotalVentaCorrida = this.$store.getters["corridas/getTotalVentaCorrida"];
      });
      this.showListaAbordajeModal = true;
    },

    getListDebouncedSubcorridas: _.debounce(function () {
      this.getListSubcorridas();
    }, 300),
    //actualiza subcorridas en componente subcorridas
    async getListSubcorridas() {
      let params = {
        ...(this.sort ? { sort: this.sort } : {}),
        filter: {
        },
        page: {
          number: this.pagination_subcorridas.currentPage,
          size: this.pagination_subcorridas.perPage,
        },
        fecha_salida: this.subcorrida.fecha_salida,
        ...(this.subcorrida.terminal_origen ? { terminal_origen_id: this.subcorrida.terminal_origen.id } : {}),
        ...(this.subcorrida.terminal_destino ? { terminal_destino_id: this.subcorrida.terminal_destino.id } : {}),
      };
      var fecha_salida = new Date((this.subcorrida.fecha_salida).setHours(0, 0, 0, 0));
      var hoy = new Date((this.subcorrida.hoy).setHours(0, 0, 0, 0));

      if(fecha_salida < hoy){
        this.subcorrida.fecha_salida = new Date();
        this.subcorrida.hoy = new Date();
        this.$notify({
          type: "danger",
          message: "No es posible seleccionar una fecha menor a la actual!",
          duration: -1
        });
      }else{
        try{
          await this.$store.dispatch("subcorridas/list", params).then(() => {
            this.subcorridas = this.$store.getters["subcorridas/list"];
            this.total_subcorridas = this.$store.getters["subcorridas/listTotal"];
          });
          //this.showSeleccionSubcorridaModal = true;
          this.loading = false;
        }catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      }
    }, 

    async getTerminales() {
      let params = {
        filter: {
        },
        page: {
          number: 1,
          size: 100000,
        },
      };
      await this.$store.dispatch("terminales/list", params).then(() => {
        this.terminales = this.$store.getters["terminales/list"];
        this.subcorrida.terminal_origen = this.terminales.find(item => item.nombre == this.boleto_info.nombre_terminal_origen);
        this.subcorrida.terminal_destino = this.terminales.find(item => item.nombre == this.boleto_info.nombre_terminal_destino);
      });
    },
    //crea fusión de abreviatura y nombre para multiselect de componente subcorridas
    nombreAbreviatura ({ nombre, abreviatura }) {
      return `${nombre} (${abreviatura})`
    },
    //control de boton intercambiar en componente subcorridas
    Intercambiar(){
      let terminal_origen = this.subcorrida.terminal_origen;
      let terminal_destino = this.subcorrida.terminal_destino;
      this.subcorrida.terminal_origen = terminal_destino;
      this.subcorrida.terminal_destino = terminal_origen;
    },

    async payEquipajeExtra(){
      this.equipajeExtra.tasa_usd_mxn = this.tasa_usd_mxn;
      this.equipajeExtra.boleto_id = this.boleto_info.id;
      this.equipajeExtra.efectivo_usd_mxn = (this.equipajeExtra.tasa_usd_mxn * this.equipajeExtra.efectivo_usd);
      if(this.equipajeExtra.efectivo_usd_mxn === 0){
        this.equipajeExtra.efectivo_usd_mxn = null;
      }
      if(this.equipajeExtra.tarjeta === 0){
        this.equipajeExtra.tarjeta = null;
      }
      if(this.equipajeExtra.deposito === 0){
        this.equipajeExtra.deposito = null;
      }
      this.equipajeExtra.total_metodos = this.calculateAcumuladoEquipaje;
      this.equipajeExtra.cambio = this.calculateCambioEquipaje;
      this.equipajeExtra.saldo_efectivo_mxn = this.equipajeExtra.efectivo_mxn - this.calculateCambioEquipaje;
      try {
        await this.$store.dispatch("boletos/vendeEquipajeExtra", this.equipajeExtra).then(() => {
          this.boleto_equipaje = this.$store.getters["boletos/vendeEquipajeExtra"];
          this.boleto_equipaje = this.boleto_equipaje.result.equipaje;
        });
        this.$notify({
          type: "success",
          message: "Se realizo venta de equipaje extra satisfactoriamente.",
          duration: -1
        });
        //this.showBoletoEquipajeModal = true;
        this.imprimir(this.boleto_equipaje, 'equipaje');
        this.getBoleto(this.boleto_info.id);
        this.showPayEquipajeExtraModal = false;
        this.resetApiValidation();
        } catch (error) {
        this.$notify({
          type: "danger",
          message: error.response.data.errors[0].detail,
          duration: -1
        });
        this.resetApiValidation();
        this.setApiValidation(error.response.data.errors);
      }
    },

    async payConfirmaReserva(){
      if(this.calculateTotalPagoReserva > this.calculateAcumuladoReserva){
        this.$notify({
          type: "danger",
          message: "No se cubre el precio total del pago de reserva!",
          duration: -1
        });
        this.payReservaLoading = false;
        return;
      }
      this.confirmarReserva.tasa_usd_mxn = this.tasa_usd_mxn;
      this.confirmarReserva.monto = this.calculateTotalPagoReserva;
      this.confirmarReserva.monto_reserva_liquidar = (this.calculateTotalPagoReserva - this.calculateTotalDevolucionReserva);
      this.confirmarReserva.efectivo_usd_mxn = (this.confirmarReserva.tasa_usd_mxn * this.confirmarReserva.efectivo_usd);
      if(this.confirmarReserva.efectivo_usd_mxn === 0){
        this.confirmarReserva.efectivo_usd_mxn = null;
      }
      if(this.confirmarReserva.tarjeta === 0){
        this.confirmarReserva.tarjeta = null;
      }
      if(this.confirmarReserva.deposito === 0){
        this.confirmarReserva.deposito = null;
      }
      this.confirmarReserva.total_metodos = this.calculateAcumuladoReserva;
      this.confirmarReserva.cambio = this.calculateCambioReserva;
      this.confirmarReserva.saldo_efectivo_mxn = this.confirmarReserva.efectivo_mxn - this.calculateCambioReserva;
      try {
        await this.$store.dispatch("boletos/confirmaReserva", this.confirmarReserva).then(() => {
          this.boletos_reservados = this.$store.getters["boletos/confirmaReserva"];
          this.boletos_reservados = this.boletos_reservados.result.boletos;
        });
        this.$notify({
          type: "success",
          message: "Se confirmo reserva satisfactoriamente.",
          duration: -1
        });
        //this.showBoletosPagoModal = true;
        this.imprimir(this.boletos_reservados, 'confirma_reserva');
        this.getVerReserva(this.boleto_info.id);
        this.getBoleto(this.boleto_info.id);
        this.resetApiValidation();
        this.selectReservaValue = 'inicial';
        this.payReservaLoading = false;
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        this.payReservaLoading = false;
        this.resetApiValidation();
        this.setApiValidation(error.response.data.errors);
        
      }
    },

    async anulaReserva(){
      this.anularReserva.monto = this.calculateTotalDevolucionReserva;
      try {
        await this.$store.dispatch("boletos/anulaReserva", this.anularReserva);
        this.$notify({
          type: "success",
          message: "Se anulo reserva satisfactoriamente.",
          duration: -1
        });
        this.showAnulaReservaConfirmacionModal = true;
        this.getVerReserva(this.boleto_info.id);
        this.getBoleto(this.boleto_info.id);
        this.resetApiValidation();
        } catch (error) {
          if (error.response.data.errors[0]) {
                this.$notify({
                    type: "danger",
                    message: error.response.data.errors[0].detail,
                    duration: -1
                });
            } else {
                this.$notify({
                    type: "danger",
                    message: "Oops, ha ocurrido un problema!",
                    duration: -1
                });
            }
        this.resetApiValidation();
        this.setApiValidation(error.response.data.errors);
      }
    },

    selectReserva(){
      var valida = this.boletos_reservados.filter(item => item.selected == true);
      if(valida.length > 0){
        if(this.selectReservaValue === 'confirmar'){
          this.showPayConfirmarReservaModal = true;
        }else{
          this.showAnulaReservaModal = true;
        }
      }else{
        this.$notify({
          type: "danger",
          message: "Es necesario seleccionar al menos un boleto",
          duration: -1
        });
        this.selectReservaValue = 'inicial';
      }
      
    },

    async getVerReserva(id) {
      try {
        await this.$store.dispatch("boletos/veReserva", id).then(() => {
          this.boletos_reservados = this.$store.getters["boletos/veReserva"];
        });
        this.showVerReservaModal = true;
        this.permiso.permiso = 'view autorizar anular reserva';
        await this.$store.dispatch("boletos/verificacion", this.permiso);
        this.anularReserva.anulado_autorizado_por = null;
        this.verBotonReserva = true;
        this.loading = false;
        }catch (error) {
          this.$notify({
            type: "danger",
            message: "No cuentas con permisos para anular reserva de boletos!",
            duration: -1
          });
        }
    },

    async editarPasajeroBoleto(id){
      this.editarNombrePasajeroBoleto.boleto_id = id;
      try {
        await this.$store.dispatch("boletos/cambiaNombrePasajeroBoleto", this.editarNombrePasajeroBoleto);
        this.$notify({
          type: "success",
          message: "Cambio de nombre de pasajero realizado satisfactoriamente.",
          duration: -1
        });
        this.editarNombrePasajeroBoleto.nombre_pasajero = null;
        this.editarNombrePasajeroBoleto.boleto_id = null;
        this.getBoleto(id);
        this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
    },
    //valida permiso
    async authReimprimirBoleto(id){
      //this.reimprimirBoleto.token = this.auth.token;
      //this.auth.permiso = 'view reimpresion boleto';
      try {
        await this.$store.dispatch("boletos/autorizacionToken", this.auth).then(() => {
          this.reimprimirBoleto.token = this.$store.getters["boletos/autorizacionToken"];
          this.reimprimirBoleto.token = this.reimprimirBoleto.token.result.token;
        });
        this.reimprimirBoleto.boleto_id = id;
        await this.$store.dispatch("boletos/reimprimeBoleto", this.reimprimirBoleto);
        this.boleto_reimpresion = this.$store.getters["boletos/reimprimeBoleto"];
        this.imprimir(this.boleto_reimpresion, 'reimprime');
        this.$notify({
          type: "success",
          message: "Se realizo reimpresión de boleto satisfactoriamente.",
          duration: -1
        });
        this.getBoleto(id);
        this.auth.token = null;
        this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
    },
    async validateReimprimirBoleto(id){
      this.permiso.permiso = 'view reimpresion boleto';
      try {
        await this.$store.dispatch("boletos/verificacion", this.permiso);
        this.reimprimirBoleto.boleto_id = id;
        await this.$store.dispatch("boletos/reimprimeBoleto", this.reimprimirBoleto);
        this.boleto_reimpresion = this.$store.getters["boletos/reimprimeBoleto"];
        this.imprimir(this.boleto_reimpresion, 'reimprime');
        this.$notify({
          type: "success",
          message: "Se realizo reimpresión de boleto satisfactoriamente.",
          duration: -1
        });
        this.getBoleto(id);
        this.closeModal();
      }catch (error) {
        this.showAutorizarReimprimirBoletoModal = true;
      }
    },
    //request anular boleto
    async anularBoletoFinal(id){
      this.anularBoleto.boleto_id = id;
      this.anularBoleto.token = this.auth.token;
      try {
        await this.$store.dispatch("boletos/anulaBoleto", this.anularBoleto);
        this.imprimir(this.boleto_info, "anula");
        this.$notify({
          type: "success",
          message: "Boleto anulado satisfactoriamente.",
          duration: -1
        });
        this.getBoleto(id);
        this.auth.token = null;
        this.showAnularBoletoModal = false;
      }catch (error) {
        if (error.response.data.errors[0]) {
            this.$notify({
                type: "danger",
                message: error.response.data.errors[0].detail,
                duration: -1
            });
        } else {
            this.$notify({
                type: "danger",
                message: "Oops, ha ocurrido un problema!",
                duration: -1
            });
        }
      }
    },
    //valida permiso
    async authAnularBoleto(){
      this.auth.permiso = 'view autorizar anular boleto';
      try {
        await this.$store.dispatch("boletos/autorizacionToken", this.auth).then(() => {
          this.anularBoleto.token = this.$store.getters["boletos/autorizacionToken"];
          this.anularBoleto.token = this.anularBoleto.token.result.token;
        });
        this.$notify({
          type: "success",
          message: "Anular boleto autorizado satisfactoriamente.",
          duration: -1
        });
        this.closeModal();
        this.showAnularBoletoModal = true;
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
    },
    //valida permiso
    async validatePermisoAnular(){
      this.permiso.permiso = 'view autorizar anular boleto';
      try {
        await this.$store.dispatch("boletos/verificacion", this.permiso);
        this.showAnularBoletoModal = true;
      }catch (error) {
        this.showAutorizarAnularBoletoModal = true;
      }
    },

    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),
    //obtiene lista de boletos para tabla principal
    async getList() {
      let params = {
        ...(this.sort ? { sort: this.sort } : {}),
        filter: {
          ...(this.query ? { search: this.query } : {}),
          ...(this.type ? { tipo: this.type } : {}),
        },
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage,
        },
      };

      await this.$store.dispatch("boletos/list", params).then(() => {
        this.boletos = this.$store.getters["boletos/list"];
        this.total = this.$store.getters["boletos/listTotal"];
      });
      this.loading = false;
    },
    //cierra diversos modales
    closeModal() {
      this.resetApiValidation();
      if(this.showAnularBoletoModal === true){
        this.showAnularBoletoModal = false;
      }
      if(this.showAutorizarAnularBoletoModal === true){
        this.showAutorizarAnularBoletoModal = false;
      }
      if(this.showAutorizarReimprimirBoletoModal === true){
        this.showAutorizarReimprimirBoletoModal = false;
      }
      if(this.showEditarPasajeroModal === true){
        this.showEditarPasajeroModal = false;
      }
      if(this.showVerReservaModal === true){
        this.selectReservaValue = 'inicial';
        this.showVerReservaModal = false;
      }
      if(this.showAutorizarCanjeBoletoModal === true){
        this.showAutorizarCanjeBoletoModal = false;
      }
      this.getList();
    },
    //obtiene información de boleto
    async getBoleto(id) {
      await this.$store.dispatch("boletos/getInfo", id).then(() => {
        this.boleto_info = this.$store.getters["boletos/getInfo"];
      });
      let me = await this.$store.getters["profile/me"];
      if(me.attributes.agencia_activa != 'sin agencia'){
          this.anularBoleto.agencia = me.relationships.agencias.data.find(item => item.attributes.nombre == me.attributes.agencia_activa);
          this.anularBoleto.agencia_id = this.anularBoleto.agencia.id;
          this.confirmarReserva.agencia_id = this.anularBoleto.agencia_id;
          this.anularReserva.agencia_id = this.confirmarReserva.agencia_id;
          this.equipajeExtra.agencia_id = this.anularReserva.agencia_id;
      }else{
        this.anularBoleto.agencia_id = null;
        this.confirmarReserva.agencia_id = null;
        this.anularReserva.agencia_id = null;
        this.equipajeExtra.agencia_id = null;
        this.canjearBoleto.agencia_id = null;
      }
      this.loading = false;
    },
    //muestra boleto
    showBoleto(row){
      this.getBoleto(row.id);
      this.showVerBoletoModal = true;
    },
    //obtiene y agrega opciones para validaciones
    async getOpciones(){
      await this.$store.dispatch("opciones/list");
      const opciones = await { ...this.$store.getters["opciones/list"] };
      this.tasa_usd_mxn = opciones.data[5].attributes.valor;
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
<style lang="scss">
 .argon-error {
   position: relative;
   bottom: 25px !important;
   color: #fb6340;
   }
   .hoverApolo:hover{
      background-color: #6074dd !important;
      color: #fff !important;
  }
  .el-select-dropdown.el-popper .el-select-dropdown__item.selected, .el-select-dropdown.el-popper.is-multiple .el-select-dropdown__item.selected{
    color: #0068a0 !important;
  }
</style>